import { Fragment as si, jsx as J, jsxs as ci } from "react/jsx-runtime";
import { g as Yt } from "./tailwind-BXrsiEcF.js";
import { forwardRef as fi } from "react";
function hi(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const pi = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, mi = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, gi = {};
function lt(e, t) {
  return (gi.jsx ? mi : pi).test(e);
}
const di = /[ \t\n\f\r]/g;
function xi(e) {
  return typeof e == "object" ? e.type === "text" ? ot(e.value) : !1 : ot(e);
}
function ot(e) {
  return e.replace(di, "") === "";
}
class He {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
He.prototype.property = {};
He.prototype.normal = {};
He.prototype.space = null;
function Xt(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new He(n, r, t);
}
function Tn(e) {
  return e.toLowerCase();
}
class le {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
le.prototype.space = null;
le.prototype.boolean = !1;
le.prototype.booleanish = !1;
le.prototype.overloadedBoolean = !1;
le.prototype.number = !1;
le.prototype.commaSeparated = !1;
le.prototype.spaceSeparated = !1;
le.prototype.commaOrSpaceSeparated = !1;
le.prototype.mustUseProperty = !1;
le.prototype.defined = !1;
let yi = 0;
const N = Ie(), W = Ie(), Gt = Ie(), I = Ie(), V = Ie(), Le = Ie(), te = Ie();
function Ie() {
  return 2 ** ++yi;
}
const An = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: N,
  booleanish: W,
  commaOrSpaceSeparated: te,
  commaSeparated: Le,
  number: I,
  overloadedBoolean: Gt,
  spaceSeparated: V
}, Symbol.toStringTag, { value: "Module" })), sn = Object.keys(An);
class Rn extends le {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), at(this, "space", i), typeof r == "number")
      for (; ++o < sn.length; ) {
        const l = sn[o];
        at(this, sn[o], (r & An[l]) === An[l]);
      }
  }
}
Rn.prototype.defined = !0;
function at(e, t, n) {
  n && (e[t] = n);
}
const ki = {}.hasOwnProperty;
function De(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (ki.call(e.properties, r)) {
      const i = e.properties[r], o = new Rn(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[Tn(r)] = r, n[Tn(o.attribute)] = r;
    }
  return new He(t, n, e.space);
}
const Kt = De({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Jt = De({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Zt(e, t) {
  return t in e ? e[t] : t;
}
function er(e, t) {
  return Zt(e, t.toLowerCase());
}
const nr = De({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: er,
  properties: { xmlns: null, xmlnsXLink: null }
}), tr = De({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: W,
    ariaAutoComplete: null,
    ariaBusy: W,
    ariaChecked: W,
    ariaColCount: I,
    ariaColIndex: I,
    ariaColSpan: I,
    ariaControls: V,
    ariaCurrent: null,
    ariaDescribedBy: V,
    ariaDetails: null,
    ariaDisabled: W,
    ariaDropEffect: V,
    ariaErrorMessage: null,
    ariaExpanded: W,
    ariaFlowTo: V,
    ariaGrabbed: W,
    ariaHasPopup: null,
    ariaHidden: W,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: V,
    ariaLevel: I,
    ariaLive: null,
    ariaModal: W,
    ariaMultiLine: W,
    ariaMultiSelectable: W,
    ariaOrientation: null,
    ariaOwns: V,
    ariaPlaceholder: null,
    ariaPosInSet: I,
    ariaPressed: W,
    ariaReadOnly: W,
    ariaRelevant: null,
    ariaRequired: W,
    ariaRoleDescription: V,
    ariaRowCount: I,
    ariaRowIndex: I,
    ariaRowSpan: I,
    ariaSelected: W,
    ariaSetSize: I,
    ariaSort: null,
    ariaValueMax: I,
    ariaValueMin: I,
    ariaValueNow: I,
    ariaValueText: null,
    role: null
  }
}), bi = De({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: er,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Le,
    acceptCharset: V,
    accessKey: V,
    action: null,
    allow: null,
    allowFullScreen: N,
    allowPaymentRequest: N,
    allowUserMedia: N,
    alt: null,
    as: null,
    async: N,
    autoCapitalize: null,
    autoComplete: V,
    autoFocus: N,
    autoPlay: N,
    blocking: V,
    capture: null,
    charSet: null,
    checked: N,
    cite: null,
    className: V,
    cols: I,
    colSpan: null,
    content: null,
    contentEditable: W,
    controls: N,
    controlsList: V,
    coords: I | Le,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: N,
    defer: N,
    dir: null,
    dirName: null,
    disabled: N,
    download: Gt,
    draggable: W,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: N,
    formTarget: null,
    headers: V,
    height: I,
    hidden: N,
    high: I,
    href: null,
    hrefLang: null,
    htmlFor: V,
    httpEquiv: V,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: N,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: N,
    itemId: null,
    itemProp: V,
    itemRef: V,
    itemScope: N,
    itemType: V,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: N,
    low: I,
    manifest: null,
    max: null,
    maxLength: I,
    media: null,
    method: null,
    min: null,
    minLength: I,
    multiple: N,
    muted: N,
    name: null,
    nonce: null,
    noModule: N,
    noValidate: N,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: N,
    optimum: I,
    pattern: null,
    ping: V,
    placeholder: null,
    playsInline: N,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: N,
    referrerPolicy: null,
    rel: V,
    required: N,
    reversed: N,
    rows: I,
    rowSpan: I,
    sandbox: V,
    scope: null,
    scoped: N,
    seamless: N,
    selected: N,
    shadowRootClonable: N,
    shadowRootDelegatesFocus: N,
    shadowRootMode: null,
    shape: null,
    size: I,
    sizes: null,
    slot: null,
    span: I,
    spellCheck: W,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: I,
    step: null,
    style: null,
    tabIndex: I,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: N,
    useMap: null,
    value: W,
    width: I,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: V,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: I,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: I,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: N,
    // Lists. Use CSS to reduce space between items instead
    declare: N,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: I,
    // `<img>` and `<object>`
    leftMargin: I,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: I,
    // `<body>`
    marginWidth: I,
    // `<body>`
    noResize: N,
    // `<frame>`
    noHref: N,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: N,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: N,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: I,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: W,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: I,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: I,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: N,
    disableRemotePlayback: N,
    prefix: null,
    property: null,
    results: I,
    security: null,
    unselectable: null
  }
}), wi = De({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Zt,
  properties: {
    about: te,
    accentHeight: I,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: I,
    amplitude: I,
    arabicForm: null,
    ascent: I,
    attributeName: null,
    attributeType: null,
    azimuth: I,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: I,
    by: null,
    calcMode: null,
    capHeight: I,
    className: V,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: I,
    diffuseConstant: I,
    direction: null,
    display: null,
    dur: null,
    divisor: I,
    dominantBaseline: null,
    download: N,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: I,
    enableBackground: null,
    end: null,
    event: null,
    exponent: I,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: I,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Le,
    g2: Le,
    glyphName: Le,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: I,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: I,
    horizOriginX: I,
    horizOriginY: I,
    id: null,
    ideographic: I,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: I,
    k: I,
    k1: I,
    k2: I,
    k3: I,
    k4: I,
    kernelMatrix: te,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: I,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: I,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: I,
    overlineThickness: I,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: I,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: V,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: I,
    pointsAtY: I,
    pointsAtZ: I,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: te,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: te,
    rev: te,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: te,
    requiredFeatures: te,
    requiredFonts: te,
    requiredFormats: te,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: I,
    specularExponent: I,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: I,
    strikethroughThickness: I,
    string: null,
    stroke: null,
    strokeDashArray: te,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: I,
    strokeOpacity: I,
    strokeWidth: null,
    style: null,
    surfaceScale: I,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: te,
    tabIndex: I,
    tableValues: null,
    target: null,
    targetX: I,
    targetY: I,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: te,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: I,
    underlineThickness: I,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: I,
    values: null,
    vAlphabetic: I,
    vMathematical: I,
    vectorEffect: null,
    vHanging: I,
    vIdeographic: I,
    version: null,
    vertAdvY: I,
    vertOriginX: I,
    vertOriginY: I,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: I,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Si = /^data[-\w.:]+$/i, ut = /-[a-z]/g, Ci = /[A-Z]/g;
function Ei(e, t) {
  const n = Tn(t);
  let r = t, i = le;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Si.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(ut, Ti);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!ut.test(o)) {
        let l = o.replace(Ci, Ii);
        l.charAt(0) !== "-" && (l = "-" + l), t = "data" + l;
      }
    }
    i = Rn;
  }
  return new i(r, t);
}
function Ii(e) {
  return "-" + e.toLowerCase();
}
function Ti(e) {
  return e.charAt(1).toUpperCase();
}
const Ai = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, Fi = Xt([Jt, Kt, nr, tr, bi], "html"), _n = Xt([Jt, Kt, nr, tr, wi], "svg");
function Pi(e) {
  return e.join(" ").trim();
}
var Pe = {}, cn, st;
function vi() {
  if (st) return cn;
  st = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, t = /\n/g, n = /^\s*/, r = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, i = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, l = /^[;\s]*/, a = /^\s+|\s+$/g, u = `
`, s = "/", f = "*", c = "", p = "comment", h = "declaration";
  cn = function(x, C) {
    if (typeof x != "string")
      throw new TypeError("First argument must be a string");
    if (!x) return [];
    C = C || {};
    var b = 1, y = 1;
    function E(z) {
      var A = z.match(t);
      A && (b += A.length);
      var M = z.lastIndexOf(u);
      y = ~M ? z.length - M : y + z.length;
    }
    function L() {
      var z = { line: b, column: y };
      return function(A) {
        return A.position = new D(z), q(), A;
      };
    }
    function D(z) {
      this.start = z, this.end = { line: b, column: y }, this.source = C.source;
    }
    D.prototype.content = x;
    function S(z) {
      var A = new Error(
        C.source + ":" + b + ":" + y + ": " + z
      );
      if (A.reason = z, A.filename = C.source, A.line = b, A.column = y, A.source = x, !C.silent) throw A;
    }
    function O(z) {
      var A = z.exec(x);
      if (A) {
        var M = A[0];
        return E(M), x = x.slice(M.length), A;
      }
    }
    function q() {
      O(n);
    }
    function R(z) {
      var A;
      for (z = z || []; A = k(); )
        A !== !1 && z.push(A);
      return z;
    }
    function k() {
      var z = L();
      if (!(s != x.charAt(0) || f != x.charAt(1))) {
        for (var A = 2; c != x.charAt(A) && (f != x.charAt(A) || s != x.charAt(A + 1)); )
          ++A;
        if (A += 2, c === x.charAt(A - 1))
          return S("End of comment missing");
        var M = x.slice(2, A - 2);
        return y += 2, E(M), x = x.slice(A), y += 2, z({
          type: p,
          comment: M
        });
      }
    }
    function P() {
      var z = L(), A = O(r);
      if (A) {
        if (k(), !O(i)) return S("property missing ':'");
        var M = O(o), Q = z({
          type: h,
          property: d(A[0].replace(e, c)),
          value: M ? d(M[0].replace(e, c)) : c
        });
        return O(l), Q;
      }
    }
    function v() {
      var z = [];
      R(z);
      for (var A; A = P(); )
        A !== !1 && (z.push(A), R(z));
      return z;
    }
    return q(), v();
  };
  function d(x) {
    return x ? x.replace(a, c) : c;
  }
  return cn;
}
var ct;
function zi() {
  if (ct) return Pe;
  ct = 1;
  var e = Pe && Pe.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(Pe, "__esModule", { value: !0 });
  var t = e(vi());
  function n(r, i) {
    var o = null;
    if (!r || typeof r != "string")
      return o;
    var l = (0, t.default)(r), a = typeof i == "function";
    return l.forEach(function(u) {
      if (u.type === "declaration") {
        var s = u.property, f = u.value;
        a ? i(s, f, u) : f && (o = o || {}, o[s] = f);
      }
    }), o;
  }
  return Pe.default = n, Pe;
}
var Li = zi();
const ft = /* @__PURE__ */ Yt(Li), Di = ft.default || ft, rr = ir("end"), Nn = ir("start");
function ir(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function Oi(e) {
  const t = Nn(e), n = rr(e);
  if (t && n)
    return { start: t, end: n };
}
function je(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? ht(e.position) : "start" in e || "end" in e ? ht(e) : "line" in e || "column" in e ? Fn(e) : "";
}
function Fn(e) {
  return pt(e && e.line) + ":" + pt(e && e.column);
}
function ht(e) {
  return Fn(e && e.start) + "-" + Fn(e && e.end);
}
function pt(e) {
  return e && typeof e == "number" ? e : 1;
}
class K extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, l = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof t == "string" ? i = t : !o.cause && t && (l = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? o.ruleId = r : (o.source = r.slice(0, u), o.ruleId = r.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const a = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = a ? a.line : void 0, this.name = je(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = l && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
K.prototype.file = "";
K.prototype.name = "";
K.prototype.reason = "";
K.prototype.message = "";
K.prototype.stack = "";
K.prototype.column = void 0;
K.prototype.line = void 0;
K.prototype.ancestors = void 0;
K.prototype.cause = void 0;
K.prototype.fatal = void 0;
K.prototype.place = void 0;
K.prototype.ruleId = void 0;
K.prototype.source = void 0;
const Bn = {}.hasOwnProperty, Mi = /* @__PURE__ */ new Map(), Ri = /[A-Z]/g, _i = /-([a-z])/g, Ni = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), Bi = /* @__PURE__ */ new Set(["td", "th"]), lr = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function ji(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = Yi(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = Qi(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? _n : Fi,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = or(i, e, void 0);
  return o && typeof o != "string" ? o : i.create(
    e,
    i.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function or(e, t, n) {
  if (t.type === "element")
    return $i(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return qi(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return Ui(e, t, n);
  if (t.type === "mdxjsEsm")
    return Hi(e, t);
  if (t.type === "root")
    return Vi(e, t, n);
  if (t.type === "text")
    return Wi(e, t);
}
function $i(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = _n, e.schema = i), e.ancestors.push(t);
  const o = ur(e, t.tagName, !1), l = Xi(e, t);
  let a = $n(e, t);
  return Ni.has(t.tagName) && (a = a.filter(function(u) {
    return typeof u == "string" ? !xi(u) : !0;
  })), ar(e, l, o, t), jn(l, a), e.ancestors.pop(), e.schema = r, e.create(t, o, l, n);
}
function qi(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  qe(e, t.position);
}
function Hi(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  qe(e, t.position);
}
function Ui(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = _n, e.schema = i), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : ur(e, t.name, !0), l = Gi(e, t), a = $n(e, t);
  return ar(e, l, o, t), jn(l, a), e.ancestors.pop(), e.schema = r, e.create(t, o, l, n);
}
function Vi(e, t, n) {
  const r = {};
  return jn(r, $n(e, t)), e.create(t, e.Fragment, r, n);
}
function Wi(e, t) {
  return t.value;
}
function ar(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function jn(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function Qi(e, t, n) {
  return r;
  function r(i, o, l, a) {
    const s = Array.isArray(l.children) ? n : t;
    return a ? s(o, l, a) : s(o, l);
  }
}
function Yi(e, t) {
  return n;
  function n(r, i, o, l) {
    const a = Array.isArray(o.children), u = Nn(r);
    return t(
      i,
      o,
      l,
      a,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function Xi(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && Bn.call(t.properties, i)) {
      const o = Ki(e, i, t.properties[i]);
      if (o) {
        const [l, a] = o;
        e.tableCellAlignToStyle && l === "align" && typeof a == "string" && Bi.has(t.tagName) ? r = a : n[l] = a;
      }
    }
  if (r) {
    const o = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function Gi(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const o = r.data.estree.body[0];
        o.type;
        const l = o.expression;
        l.type;
        const a = l.properties[0];
        a.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        qe(e, t.position);
    else {
      const i = r.name;
      let o;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, o = e.evaluater.evaluateExpression(a.expression);
        } else
          qe(e, t.position);
      else
        o = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      o;
    }
  return n;
}
function $n(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : Mi;
  for (; ++r < t.children.length; ) {
    const o = t.children[r];
    let l;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const s = i.get(u) || 0;
        l = u + "-" + s, i.set(u, s + 1);
      }
    }
    const a = or(e, o, l);
    a !== void 0 && n.push(a);
  }
  return n;
}
function Ki(e, t, n) {
  const r = Ei(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? hi(n) : Pi(n)), r.property === "style") {
      let i = typeof n == "object" ? n : Ji(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = Zi(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? Ai[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function Ji(e, t) {
  const n = {};
  try {
    Di(t, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        i
      ), l = new K("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw l.file = e.filePath || void 0, l.url = lr + "#cannot-parse-style-attribute", l;
    }
  }
  return n;
  function r(i, o) {
    let l = i;
    l.slice(0, 2) !== "--" && (l.slice(0, 4) === "-ms-" && (l = "ms-" + l.slice(4)), l = l.replace(_i, nl)), n[l] = o;
  }
}
function ur(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let o = -1, l;
    for (; ++o < i.length; ) {
      const a = lt(i[o]) ? { type: "Identifier", name: i[o] } : { type: "Literal", value: i[o] };
      l = l ? {
        type: "MemberExpression",
        object: l,
        property: a,
        computed: !!(o && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = l;
  } else
    r = lt(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return Bn.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  qe(e);
}
function qe(e, t) {
  const n = new K(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = lr + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function Zi(e) {
  const t = {};
  let n;
  for (n in e)
    Bn.call(e, n) && (t[el(n)] = e[n]);
  return t;
}
function el(e) {
  let t = e.replace(Ri, tl);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function nl(e, t) {
  return t.toUpperCase();
}
function tl(e) {
  return "-" + e.toLowerCase();
}
const fn = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, rl = {};
function qn(e, t) {
  const n = rl, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return sr(e, r, i);
}
function sr(e, t, n) {
  if (il(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return mt(e.children, t, n);
  }
  return Array.isArray(e) ? mt(e, t, n) : "";
}
function mt(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = sr(e[i], t, n);
  return r.join("");
}
function il(e) {
  return !!(e && typeof e == "object");
}
const gt = document.createElement("i");
function Hn(e) {
  const t = "&" + e + ";";
  gt.innerHTML = t;
  const n = gt.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function ie(e, t, n, r) {
  const i = e.length;
  let o = 0, l;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    l = Array.from(r), l.unshift(t, n), e.splice(...l);
  else
    for (n && e.splice(t, n); o < r.length; )
      l = r.slice(o, o + 1e4), l.unshift(t, 0), e.splice(...l), o += 1e4, t += 1e4;
}
function re(e, t) {
  return e.length > 0 ? (ie(e, e.length, 0, t), e) : t;
}
const dt = {}.hasOwnProperty;
function cr(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    ll(t, e[n]);
  return t;
}
function ll(e, t) {
  let n;
  for (n in t) {
    const i = (dt.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let l;
    if (o)
      for (l in o) {
        dt.call(i, l) || (i[l] = []);
        const a = o[l];
        ol(
          // @ts-expect-error Looks like a list.
          i[l],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function ol(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  ie(e, 0, 0, r);
}
function fr(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function ce(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Z = be(/[A-Za-z]/), G = be(/[\dA-Za-z]/), al = be(/[#-'*+\--9=?A-Z^-~]/);
function Je(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Pn = be(/\d/), ul = be(/[\dA-Fa-f]/), sl = be(/[!-/:-@[-`{-~]/);
function F(e) {
  return e !== null && e < -2;
}
function U(e) {
  return e !== null && (e < 0 || e === 32);
}
function j(e) {
  return e === -2 || e === -1 || e === 32;
}
const rn = be(new RegExp("\\p{P}|\\p{S}", "u")), Ee = be(/\s/);
function be(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function Oe(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let l = "";
    if (o === 37 && G(e.charCodeAt(n + 1)) && G(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (l = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const a = e.charCodeAt(n + 1);
      o < 56320 && a > 56319 && a < 57344 ? (l = String.fromCharCode(o, a), i = 1) : l = "�";
    } else
      l = String.fromCharCode(o);
    l && (t.push(e.slice(r, n), encodeURIComponent(l)), r = n + i + 1, l = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function B(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return l;
  function l(u) {
    return j(u) ? (e.enter(n), a(u)) : t(u);
  }
  function a(u) {
    return j(u) && o++ < i ? (e.consume(u), a) : (e.exit(n), t(u));
  }
}
const cl = {
  tokenize: fl
};
function fl(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), B(e, t, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), o(a);
  }
  function o(a) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, l(a);
  }
  function l(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return F(a) ? (e.consume(a), e.exit("chunkText"), o) : (e.consume(a), l);
  }
}
const hl = {
  tokenize: pl
}, xt = {
  tokenize: ml
};
function pl(e) {
  const t = this, n = [];
  let r = 0, i, o, l;
  return a;
  function a(E) {
    if (r < n.length) {
      const L = n[r];
      return t.containerState = L[1], e.attempt(
        L[0].continuation,
        u,
        s
      )(E);
    }
    return s(E);
  }
  function u(E) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && y();
      const L = t.events.length;
      let D = L, S;
      for (; D--; )
        if (t.events[D][0] === "exit" && t.events[D][1].type === "chunkFlow") {
          S = t.events[D][1].end;
          break;
        }
      b(r);
      let O = L;
      for (; O < t.events.length; )
        t.events[O][1].end = Object.assign({}, S), O++;
      return ie(
        t.events,
        D + 1,
        0,
        t.events.slice(L)
      ), t.events.length = O, s(E);
    }
    return a(E);
  }
  function s(E) {
    if (r === n.length) {
      if (!i)
        return p(E);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return d(E);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      xt,
      f,
      c
    )(E);
  }
  function f(E) {
    return i && y(), b(r), p(E);
  }
  function c(E) {
    return t.parser.lazy[t.now().line] = r !== n.length, l = t.now().offset, d(E);
  }
  function p(E) {
    return t.containerState = {}, e.attempt(
      xt,
      h,
      d
    )(E);
  }
  function h(E) {
    return r++, n.push([t.currentConstruct, t.containerState]), p(E);
  }
  function d(E) {
    if (E === null) {
      i && y(), b(0), e.consume(E);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), x(E);
  }
  function x(E) {
    if (E === null) {
      C(e.exit("chunkFlow"), !0), b(0), e.consume(E);
      return;
    }
    return F(E) ? (e.consume(E), C(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, a) : (e.consume(E), x);
  }
  function C(E, L) {
    const D = t.sliceStream(E);
    if (L && D.push(null), E.previous = o, o && (o.next = E), o = E, i.defineSkip(E.start), i.write(D), t.parser.lazy[E.start.line]) {
      let S = i.events.length;
      for (; S--; )
        if (
          // The token starts before the line ending…
          i.events[S][1].start.offset < l && // …and either is not ended yet…
          (!i.events[S][1].end || // …or ends after it.
          i.events[S][1].end.offset > l)
        )
          return;
      const O = t.events.length;
      let q = O, R, k;
      for (; q--; )
        if (t.events[q][0] === "exit" && t.events[q][1].type === "chunkFlow") {
          if (R) {
            k = t.events[q][1].end;
            break;
          }
          R = !0;
        }
      for (b(r), S = O; S < t.events.length; )
        t.events[S][1].end = Object.assign({}, k), S++;
      ie(
        t.events,
        q + 1,
        0,
        t.events.slice(O)
      ), t.events.length = S;
    }
  }
  function b(E) {
    let L = n.length;
    for (; L-- > E; ) {
      const D = n[L];
      t.containerState = D[1], D[0].exit.call(t, e);
    }
    n.length = E;
  }
  function y() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function ml(e, t, n) {
  return B(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Ze(e) {
  if (e === null || U(e) || Ee(e))
    return 1;
  if (rn(e))
    return 2;
}
function ln(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const vn = {
  name: "attention",
  tokenize: dl,
  resolveAll: gl
};
function gl(e, t) {
  let n = -1, r, i, o, l, a, u, s, f;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const c = Object.assign({}, e[r][1].end), p = Object.assign({}, e[n][1].start);
          yt(c, -u), yt(p, u), l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: c,
            end: Object.assign({}, e[r][1].end)
          }, a = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: p
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: u > 1 ? "strong" : "emphasis",
            start: Object.assign({}, l.start),
            end: Object.assign({}, a.end)
          }, e[r][1].end = Object.assign({}, l.start), e[n][1].start = Object.assign({}, a.end), s = [], e[r][1].end.offset - e[r][1].start.offset && (s = re(s, [["enter", e[r][1], t], ["exit", e[r][1], t]])), s = re(s, [["enter", i, t], ["enter", l, t], ["exit", l, t], ["enter", o, t]]), s = re(s, ln(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), s = re(s, [["exit", o, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (f = 2, s = re(s, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : f = 0, ie(e, r - 1, n - r + 3, s), n = r + s.length - f - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function dl(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Ze(r);
  let o;
  return l;
  function l(u) {
    return o = u, e.enter("attentionSequence"), a(u);
  }
  function a(u) {
    if (u === o)
      return e.consume(u), a;
    const s = e.exit("attentionSequence"), f = Ze(u), c = !f || f === 2 && i || n.includes(u), p = !i || i === 2 && f || n.includes(r);
    return s._open = !!(o === 42 ? c : c && (i || !p)), s._close = !!(o === 42 ? p : p && (f || !c)), t(u);
  }
}
function yt(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const xl = {
  name: "autolink",
  tokenize: yl
};
function yl(e, t, n) {
  let r = 0;
  return i;
  function i(h) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(h) {
    return Z(h) ? (e.consume(h), l) : h === 64 ? n(h) : s(h);
  }
  function l(h) {
    return h === 43 || h === 45 || h === 46 || G(h) ? (r = 1, a(h)) : s(h);
  }
  function a(h) {
    return h === 58 ? (e.consume(h), r = 0, u) : (h === 43 || h === 45 || h === 46 || G(h)) && r++ < 32 ? (e.consume(h), a) : (r = 0, s(h));
  }
  function u(h) {
    return h === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : h === null || h === 32 || h === 60 || Je(h) ? n(h) : (e.consume(h), u);
  }
  function s(h) {
    return h === 64 ? (e.consume(h), f) : al(h) ? (e.consume(h), s) : n(h);
  }
  function f(h) {
    return G(h) ? c(h) : n(h);
  }
  function c(h) {
    return h === 46 ? (e.consume(h), r = 0, f) : h === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(h), e.exit("autolinkMarker"), e.exit("autolink"), t) : p(h);
  }
  function p(h) {
    if ((h === 45 || G(h)) && r++ < 63) {
      const d = h === 45 ? p : c;
      return e.consume(h), d;
    }
    return n(h);
  }
}
const Ue = {
  tokenize: kl,
  partial: !0
};
function kl(e, t, n) {
  return r;
  function r(o) {
    return j(o) ? B(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || F(o) ? t(o) : n(o);
  }
}
const hr = {
  name: "blockQuote",
  tokenize: bl,
  continuation: {
    tokenize: wl
  },
  exit: Sl
};
function bl(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    if (l === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(l), e.exit("blockQuoteMarker"), o;
    }
    return n(l);
  }
  function o(l) {
    return j(l) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(l), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(l));
  }
}
function wl(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return j(l) ? B(e, o, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l) : o(l);
  }
  function o(l) {
    return e.attempt(hr, t, n)(l);
  }
}
function Sl(e) {
  e.exit("blockQuote");
}
const pr = {
  name: "characterEscape",
  tokenize: Cl
};
function Cl(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return sl(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const mr = {
  name: "characterReference",
  tokenize: El
};
function El(e, t, n) {
  const r = this;
  let i = 0, o, l;
  return a;
  function a(c) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), u;
  }
  function u(c) {
    return c === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(c), e.exit("characterReferenceMarkerNumeric"), s) : (e.enter("characterReferenceValue"), o = 31, l = G, f(c));
  }
  function s(c) {
    return c === 88 || c === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(c), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, l = ul, f) : (e.enter("characterReferenceValue"), o = 7, l = Pn, f(c));
  }
  function f(c) {
    if (c === 59 && i) {
      const p = e.exit("characterReferenceValue");
      return l === G && !Hn(r.sliceSerialize(p)) ? n(c) : (e.enter("characterReferenceMarker"), e.consume(c), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return l(c) && i++ < o ? (e.consume(c), f) : n(c);
  }
}
const kt = {
  tokenize: Tl,
  partial: !0
}, bt = {
  name: "codeFenced",
  tokenize: Il,
  concrete: !0
};
function Il(e, t, n) {
  const r = this, i = {
    tokenize: D,
    partial: !0
  };
  let o = 0, l = 0, a;
  return u;
  function u(S) {
    return s(S);
  }
  function s(S) {
    const O = r.events[r.events.length - 1];
    return o = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, a = S, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), f(S);
  }
  function f(S) {
    return S === a ? (l++, e.consume(S), f) : l < 3 ? n(S) : (e.exit("codeFencedFenceSequence"), j(S) ? B(e, c, "whitespace")(S) : c(S));
  }
  function c(S) {
    return S === null || F(S) ? (e.exit("codeFencedFence"), r.interrupt ? t(S) : e.check(kt, x, L)(S)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p(S));
  }
  function p(S) {
    return S === null || F(S) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), c(S)) : j(S) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), B(e, h, "whitespace")(S)) : S === 96 && S === a ? n(S) : (e.consume(S), p);
  }
  function h(S) {
    return S === null || F(S) ? c(S) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), d(S));
  }
  function d(S) {
    return S === null || F(S) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), c(S)) : S === 96 && S === a ? n(S) : (e.consume(S), d);
  }
  function x(S) {
    return e.attempt(i, L, C)(S);
  }
  function C(S) {
    return e.enter("lineEnding"), e.consume(S), e.exit("lineEnding"), b;
  }
  function b(S) {
    return o > 0 && j(S) ? B(e, y, "linePrefix", o + 1)(S) : y(S);
  }
  function y(S) {
    return S === null || F(S) ? e.check(kt, x, L)(S) : (e.enter("codeFlowValue"), E(S));
  }
  function E(S) {
    return S === null || F(S) ? (e.exit("codeFlowValue"), y(S)) : (e.consume(S), E);
  }
  function L(S) {
    return e.exit("codeFenced"), t(S);
  }
  function D(S, O, q) {
    let R = 0;
    return k;
    function k(M) {
      return S.enter("lineEnding"), S.consume(M), S.exit("lineEnding"), P;
    }
    function P(M) {
      return S.enter("codeFencedFence"), j(M) ? B(S, v, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(M) : v(M);
    }
    function v(M) {
      return M === a ? (S.enter("codeFencedFenceSequence"), z(M)) : q(M);
    }
    function z(M) {
      return M === a ? (R++, S.consume(M), z) : R >= l ? (S.exit("codeFencedFenceSequence"), j(M) ? B(S, A, "whitespace")(M) : A(M)) : q(M);
    }
    function A(M) {
      return M === null || F(M) ? (S.exit("codeFencedFence"), O(M)) : q(M);
    }
  }
}
function Tl(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return l === null ? n(l) : (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), o);
  }
  function o(l) {
    return r.parser.lazy[r.now().line] ? n(l) : t(l);
  }
}
const hn = {
  name: "codeIndented",
  tokenize: Fl
}, Al = {
  tokenize: Pl,
  partial: !0
};
function Fl(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("codeIndented"), B(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const f = r.events[r.events.length - 1];
    return f && f[1].type === "linePrefix" && f[2].sliceSerialize(f[1], !0).length >= 4 ? l(s) : n(s);
  }
  function l(s) {
    return s === null ? u(s) : F(s) ? e.attempt(Al, l, u)(s) : (e.enter("codeFlowValue"), a(s));
  }
  function a(s) {
    return s === null || F(s) ? (e.exit("codeFlowValue"), l(s)) : (e.consume(s), a);
  }
  function u(s) {
    return e.exit("codeIndented"), t(s);
  }
}
function Pl(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return r.parser.lazy[r.now().line] ? n(l) : F(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), i) : B(e, o, "linePrefix", 5)(l);
  }
  function o(l) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(l) : F(l) ? i(l) : n(l);
  }
}
const vl = {
  name: "codeText",
  tokenize: Dl,
  resolve: zl,
  previous: Ll
};
function zl(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Ll(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Dl(e, t, n) {
  let r = 0, i, o;
  return l;
  function l(c) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(c);
  }
  function a(c) {
    return c === 96 ? (e.consume(c), r++, a) : (e.exit("codeTextSequence"), u(c));
  }
  function u(c) {
    return c === null ? n(c) : c === 32 ? (e.enter("space"), e.consume(c), e.exit("space"), u) : c === 96 ? (o = e.enter("codeTextSequence"), i = 0, f(c)) : F(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), u) : (e.enter("codeTextData"), s(c));
  }
  function s(c) {
    return c === null || c === 32 || c === 96 || F(c) ? (e.exit("codeTextData"), u(c)) : (e.consume(c), s);
  }
  function f(c) {
    return c === 96 ? (e.consume(c), i++, f) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(c)) : (o.type = "codeTextData", s(c));
  }
}
class Ol {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Ne(this.left, r), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Ne(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Ne(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Ne(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Ne(this.left, n.reverse());
      }
  }
}
function Ne(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function gr(e) {
  const t = {};
  let n = -1, r, i, o, l, a, u, s;
  const f = new Ol(e);
  for (; ++n < f.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = f.get(n), n && r[1].type === "chunkFlow" && f.get(n - 1)[1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Ml(f, n)), n = t[n], s = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (l = f.get(o), l[1].type === "lineEnding" || l[1].type === "lineEndingBlank"); )
        l[0] === "enter" && (i && (f.get(i)[1].type = "lineEndingBlank"), l[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, f.get(i)[1].start), a = f.slice(i, n), a.unshift(r), f.splice(i, n - i + 1, a));
    }
  }
  return ie(e, 0, Number.POSITIVE_INFINITY, f.slice(0)), !s;
}
function Ml(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const o = [], l = n._tokenizer || r.parser[n.contentType](n.start), a = l.events, u = [], s = {};
  let f, c, p = -1, h = n, d = 0, x = 0;
  const C = [x];
  for (; h; ) {
    for (; e.get(++i)[1] !== h; )
      ;
    o.push(i), h._tokenizer || (f = r.sliceStream(h), h.next || f.push(null), c && l.defineSkip(h.start), h._isInFirstContentOfListItem && (l._gfmTasklistFirstContentOfListItem = !0), l.write(f), h._isInFirstContentOfListItem && (l._gfmTasklistFirstContentOfListItem = void 0)), c = h, h = h.next;
  }
  for (h = n; ++p < a.length; )
    // Find a void token that includes a break.
    a[p][0] === "exit" && a[p - 1][0] === "enter" && a[p][1].type === a[p - 1][1].type && a[p][1].start.line !== a[p][1].end.line && (x = p + 1, C.push(x), h._tokenizer = void 0, h.previous = void 0, h = h.next);
  for (l.events = [], h ? (h._tokenizer = void 0, h.previous = void 0) : C.pop(), p = C.length; p--; ) {
    const b = a.slice(C[p], C[p + 1]), y = o.pop();
    u.push([y, y + b.length - 1]), e.splice(y, 2, b);
  }
  for (u.reverse(), p = -1; ++p < u.length; )
    s[d + u[p][0]] = d + u[p][1], d += u[p][1] - u[p][0] - 1;
  return s;
}
const Rl = {
  tokenize: Bl,
  resolve: Nl
}, _l = {
  tokenize: jl,
  partial: !0
};
function Nl(e) {
  return gr(e), e;
}
function Bl(e, t) {
  let n;
  return r;
  function r(a) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? o(a) : F(a) ? e.check(_l, l, o)(a) : (e.consume(a), i);
  }
  function o(a) {
    return e.exit("chunkContent"), e.exit("content"), t(a);
  }
  function l(a) {
    return e.consume(a), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function jl(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), B(e, o, "linePrefix");
  }
  function o(l) {
    if (l === null || F(l))
      return n(l);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(l) : e.interrupt(r.parser.constructs.flow, n, t)(l);
  }
}
function dr(e, t, n, r, i, o, l, a, u) {
  const s = u || Number.POSITIVE_INFINITY;
  let f = 0;
  return c;
  function c(b) {
    return b === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(b), e.exit(o), p) : b === null || b === 32 || b === 41 || Je(b) ? n(b) : (e.enter(r), e.enter(l), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), x(b));
  }
  function p(b) {
    return b === 62 ? (e.enter(o), e.consume(b), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), h(b));
  }
  function h(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(a), p(b)) : b === null || b === 60 || F(b) ? n(b) : (e.consume(b), b === 92 ? d : h);
  }
  function d(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), h) : h(b);
  }
  function x(b) {
    return !f && (b === null || b === 41 || U(b)) ? (e.exit("chunkString"), e.exit(a), e.exit(l), e.exit(r), t(b)) : f < s && b === 40 ? (e.consume(b), f++, x) : b === 41 ? (e.consume(b), f--, x) : b === null || b === 32 || b === 40 || Je(b) ? n(b) : (e.consume(b), b === 92 ? C : x);
  }
  function C(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), x) : x(b);
  }
}
function xr(e, t, n, r, i, o) {
  const l = this;
  let a = 0, u;
  return s;
  function s(h) {
    return e.enter(r), e.enter(i), e.consume(h), e.exit(i), e.enter(o), f;
  }
  function f(h) {
    return a > 999 || h === null || h === 91 || h === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    h === 94 && !a && "_hiddenFootnoteSupport" in l.parser.constructs ? n(h) : h === 93 ? (e.exit(o), e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : F(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), f) : (e.enter("chunkString", {
      contentType: "string"
    }), c(h));
  }
  function c(h) {
    return h === null || h === 91 || h === 93 || F(h) || a++ > 999 ? (e.exit("chunkString"), f(h)) : (e.consume(h), u || (u = !j(h)), h === 92 ? p : c);
  }
  function p(h) {
    return h === 91 || h === 92 || h === 93 ? (e.consume(h), a++, c) : c(h);
  }
}
function yr(e, t, n, r, i, o) {
  let l;
  return a;
  function a(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(r), e.enter(i), e.consume(p), e.exit(i), l = p === 40 ? 41 : p, u) : n(p);
  }
  function u(p) {
    return p === l ? (e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : (e.enter(o), s(p));
  }
  function s(p) {
    return p === l ? (e.exit(o), u(l)) : p === null ? n(p) : F(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), B(e, s, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === l || p === null || F(p) ? (e.exit("chunkString"), s(p)) : (e.consume(p), p === 92 ? c : f);
  }
  function c(p) {
    return p === l || p === 92 ? (e.consume(p), f) : f(p);
  }
}
function $e(e, t) {
  let n;
  return r;
  function r(i) {
    return F(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : j(i) ? B(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const $l = {
  name: "definition",
  tokenize: Hl
}, ql = {
  tokenize: Ul,
  partial: !0
};
function Hl(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(h) {
    return e.enter("definition"), l(h);
  }
  function l(h) {
    return xr.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(h);
  }
  function a(h) {
    return i = ce(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), h === 58 ? (e.enter("definitionMarker"), e.consume(h), e.exit("definitionMarker"), u) : n(h);
  }
  function u(h) {
    return U(h) ? $e(e, s)(h) : s(h);
  }
  function s(h) {
    return dr(
      e,
      f,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(h);
  }
  function f(h) {
    return e.attempt(ql, c, c)(h);
  }
  function c(h) {
    return j(h) ? B(e, p, "whitespace")(h) : p(h);
  }
  function p(h) {
    return h === null || F(h) ? (e.exit("definition"), r.parser.defined.push(i), t(h)) : n(h);
  }
}
function Ul(e, t, n) {
  return r;
  function r(a) {
    return U(a) ? $e(e, i)(a) : n(a);
  }
  function i(a) {
    return yr(e, o, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function o(a) {
    return j(a) ? B(e, l, "whitespace")(a) : l(a);
  }
  function l(a) {
    return a === null || F(a) ? t(a) : n(a);
  }
}
const Vl = {
  name: "hardBreakEscape",
  tokenize: Wl
};
function Wl(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return F(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const Ql = {
  name: "headingAtx",
  tokenize: Xl,
  resolve: Yl
};
function Yl(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, ie(e, r, n - r + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function Xl(e, t, n) {
  let r = 0;
  return i;
  function i(f) {
    return e.enter("atxHeading"), o(f);
  }
  function o(f) {
    return e.enter("atxHeadingSequence"), l(f);
  }
  function l(f) {
    return f === 35 && r++ < 6 ? (e.consume(f), l) : f === null || U(f) ? (e.exit("atxHeadingSequence"), a(f)) : n(f);
  }
  function a(f) {
    return f === 35 ? (e.enter("atxHeadingSequence"), u(f)) : f === null || F(f) ? (e.exit("atxHeading"), t(f)) : j(f) ? B(e, a, "whitespace")(f) : (e.enter("atxHeadingText"), s(f));
  }
  function u(f) {
    return f === 35 ? (e.consume(f), u) : (e.exit("atxHeadingSequence"), a(f));
  }
  function s(f) {
    return f === null || f === 35 || U(f) ? (e.exit("atxHeadingText"), a(f)) : (e.consume(f), s);
  }
}
const Gl = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], wt = ["pre", "script", "style", "textarea"], Kl = {
  name: "htmlFlow",
  tokenize: no,
  resolveTo: eo,
  concrete: !0
}, Jl = {
  tokenize: ro,
  partial: !0
}, Zl = {
  tokenize: to,
  partial: !0
};
function eo(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function no(e, t, n) {
  const r = this;
  let i, o, l, a, u;
  return s;
  function s(g) {
    return f(g);
  }
  function f(g) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(g), c;
  }
  function c(g) {
    return g === 33 ? (e.consume(g), p) : g === 47 ? (e.consume(g), o = !0, x) : g === 63 ? (e.consume(g), i = 3, r.interrupt ? t : m) : Z(g) ? (e.consume(g), l = String.fromCharCode(g), C) : n(g);
  }
  function p(g) {
    return g === 45 ? (e.consume(g), i = 2, h) : g === 91 ? (e.consume(g), i = 5, a = 0, d) : Z(g) ? (e.consume(g), i = 4, r.interrupt ? t : m) : n(g);
  }
  function h(g) {
    return g === 45 ? (e.consume(g), r.interrupt ? t : m) : n(g);
  }
  function d(g) {
    const ue = "CDATA[";
    return g === ue.charCodeAt(a++) ? (e.consume(g), a === ue.length ? r.interrupt ? t : v : d) : n(g);
  }
  function x(g) {
    return Z(g) ? (e.consume(g), l = String.fromCharCode(g), C) : n(g);
  }
  function C(g) {
    if (g === null || g === 47 || g === 62 || U(g)) {
      const ue = g === 47, we = l.toLowerCase();
      return !ue && !o && wt.includes(we) ? (i = 1, r.interrupt ? t(g) : v(g)) : Gl.includes(l.toLowerCase()) ? (i = 6, ue ? (e.consume(g), b) : r.interrupt ? t(g) : v(g)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(g) : o ? y(g) : E(g));
    }
    return g === 45 || G(g) ? (e.consume(g), l += String.fromCharCode(g), C) : n(g);
  }
  function b(g) {
    return g === 62 ? (e.consume(g), r.interrupt ? t : v) : n(g);
  }
  function y(g) {
    return j(g) ? (e.consume(g), y) : k(g);
  }
  function E(g) {
    return g === 47 ? (e.consume(g), k) : g === 58 || g === 95 || Z(g) ? (e.consume(g), L) : j(g) ? (e.consume(g), E) : k(g);
  }
  function L(g) {
    return g === 45 || g === 46 || g === 58 || g === 95 || G(g) ? (e.consume(g), L) : D(g);
  }
  function D(g) {
    return g === 61 ? (e.consume(g), S) : j(g) ? (e.consume(g), D) : E(g);
  }
  function S(g) {
    return g === null || g === 60 || g === 61 || g === 62 || g === 96 ? n(g) : g === 34 || g === 39 ? (e.consume(g), u = g, O) : j(g) ? (e.consume(g), S) : q(g);
  }
  function O(g) {
    return g === u ? (e.consume(g), u = null, R) : g === null || F(g) ? n(g) : (e.consume(g), O);
  }
  function q(g) {
    return g === null || g === 34 || g === 39 || g === 47 || g === 60 || g === 61 || g === 62 || g === 96 || U(g) ? D(g) : (e.consume(g), q);
  }
  function R(g) {
    return g === 47 || g === 62 || j(g) ? E(g) : n(g);
  }
  function k(g) {
    return g === 62 ? (e.consume(g), P) : n(g);
  }
  function P(g) {
    return g === null || F(g) ? v(g) : j(g) ? (e.consume(g), P) : n(g);
  }
  function v(g) {
    return g === 45 && i === 2 ? (e.consume(g), Q) : g === 60 && i === 1 ? (e.consume(g), Y) : g === 62 && i === 4 ? (e.consume(g), ae) : g === 63 && i === 3 ? (e.consume(g), m) : g === 93 && i === 5 ? (e.consume(g), pe) : F(g) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(Jl, me, z)(g)) : g === null || F(g) ? (e.exit("htmlFlowData"), z(g)) : (e.consume(g), v);
  }
  function z(g) {
    return e.check(Zl, A, me)(g);
  }
  function A(g) {
    return e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), M;
  }
  function M(g) {
    return g === null || F(g) ? z(g) : (e.enter("htmlFlowData"), v(g));
  }
  function Q(g) {
    return g === 45 ? (e.consume(g), m) : v(g);
  }
  function Y(g) {
    return g === 47 ? (e.consume(g), l = "", oe) : v(g);
  }
  function oe(g) {
    if (g === 62) {
      const ue = l.toLowerCase();
      return wt.includes(ue) ? (e.consume(g), ae) : v(g);
    }
    return Z(g) && l.length < 8 ? (e.consume(g), l += String.fromCharCode(g), oe) : v(g);
  }
  function pe(g) {
    return g === 93 ? (e.consume(g), m) : v(g);
  }
  function m(g) {
    return g === 62 ? (e.consume(g), ae) : g === 45 && i === 2 ? (e.consume(g), m) : v(g);
  }
  function ae(g) {
    return g === null || F(g) ? (e.exit("htmlFlowData"), me(g)) : (e.consume(g), ae);
  }
  function me(g) {
    return e.exit("htmlFlow"), t(g);
  }
}
function to(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return F(l) ? (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), o) : n(l);
  }
  function o(l) {
    return r.parser.lazy[r.now().line] ? n(l) : t(l);
  }
}
function ro(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Ue, t, n);
  }
}
const io = {
  name: "htmlText",
  tokenize: lo
};
function lo(e, t, n) {
  const r = this;
  let i, o, l;
  return a;
  function a(m) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(m), u;
  }
  function u(m) {
    return m === 33 ? (e.consume(m), s) : m === 47 ? (e.consume(m), D) : m === 63 ? (e.consume(m), E) : Z(m) ? (e.consume(m), q) : n(m);
  }
  function s(m) {
    return m === 45 ? (e.consume(m), f) : m === 91 ? (e.consume(m), o = 0, d) : Z(m) ? (e.consume(m), y) : n(m);
  }
  function f(m) {
    return m === 45 ? (e.consume(m), h) : n(m);
  }
  function c(m) {
    return m === null ? n(m) : m === 45 ? (e.consume(m), p) : F(m) ? (l = c, Y(m)) : (e.consume(m), c);
  }
  function p(m) {
    return m === 45 ? (e.consume(m), h) : c(m);
  }
  function h(m) {
    return m === 62 ? Q(m) : m === 45 ? p(m) : c(m);
  }
  function d(m) {
    const ae = "CDATA[";
    return m === ae.charCodeAt(o++) ? (e.consume(m), o === ae.length ? x : d) : n(m);
  }
  function x(m) {
    return m === null ? n(m) : m === 93 ? (e.consume(m), C) : F(m) ? (l = x, Y(m)) : (e.consume(m), x);
  }
  function C(m) {
    return m === 93 ? (e.consume(m), b) : x(m);
  }
  function b(m) {
    return m === 62 ? Q(m) : m === 93 ? (e.consume(m), b) : x(m);
  }
  function y(m) {
    return m === null || m === 62 ? Q(m) : F(m) ? (l = y, Y(m)) : (e.consume(m), y);
  }
  function E(m) {
    return m === null ? n(m) : m === 63 ? (e.consume(m), L) : F(m) ? (l = E, Y(m)) : (e.consume(m), E);
  }
  function L(m) {
    return m === 62 ? Q(m) : E(m);
  }
  function D(m) {
    return Z(m) ? (e.consume(m), S) : n(m);
  }
  function S(m) {
    return m === 45 || G(m) ? (e.consume(m), S) : O(m);
  }
  function O(m) {
    return F(m) ? (l = O, Y(m)) : j(m) ? (e.consume(m), O) : Q(m);
  }
  function q(m) {
    return m === 45 || G(m) ? (e.consume(m), q) : m === 47 || m === 62 || U(m) ? R(m) : n(m);
  }
  function R(m) {
    return m === 47 ? (e.consume(m), Q) : m === 58 || m === 95 || Z(m) ? (e.consume(m), k) : F(m) ? (l = R, Y(m)) : j(m) ? (e.consume(m), R) : Q(m);
  }
  function k(m) {
    return m === 45 || m === 46 || m === 58 || m === 95 || G(m) ? (e.consume(m), k) : P(m);
  }
  function P(m) {
    return m === 61 ? (e.consume(m), v) : F(m) ? (l = P, Y(m)) : j(m) ? (e.consume(m), P) : R(m);
  }
  function v(m) {
    return m === null || m === 60 || m === 61 || m === 62 || m === 96 ? n(m) : m === 34 || m === 39 ? (e.consume(m), i = m, z) : F(m) ? (l = v, Y(m)) : j(m) ? (e.consume(m), v) : (e.consume(m), A);
  }
  function z(m) {
    return m === i ? (e.consume(m), i = void 0, M) : m === null ? n(m) : F(m) ? (l = z, Y(m)) : (e.consume(m), z);
  }
  function A(m) {
    return m === null || m === 34 || m === 39 || m === 60 || m === 61 || m === 96 ? n(m) : m === 47 || m === 62 || U(m) ? R(m) : (e.consume(m), A);
  }
  function M(m) {
    return m === 47 || m === 62 || U(m) ? R(m) : n(m);
  }
  function Q(m) {
    return m === 62 ? (e.consume(m), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(m);
  }
  function Y(m) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), oe;
  }
  function oe(m) {
    return j(m) ? B(e, pe, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(m) : pe(m);
  }
  function pe(m) {
    return e.enter("htmlTextData"), l(m);
  }
}
const Un = {
  name: "labelEnd",
  tokenize: fo,
  resolveTo: co,
  resolveAll: so
}, oo = {
  tokenize: ho
}, ao = {
  tokenize: po
}, uo = {
  tokenize: mo
};
function so(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function co(e, t) {
  let n = e.length, r = 0, i, o, l, a;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (l) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (l = n);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, s = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[l][1].end)
  }, f = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[l - 2][1].start)
  };
  return a = [["enter", u, t], ["enter", s, t]], a = re(a, e.slice(o + 1, o + r + 3)), a = re(a, [["enter", f, t]]), a = re(a, ln(t.parser.constructs.insideSpan.null, e.slice(o + r + 4, l - 3), t)), a = re(a, [["exit", f, t], e[l - 2], e[l - 1], ["exit", s, t]]), a = re(a, e.slice(l + 1)), a = re(a, [["exit", u, t]]), ie(e, o, e.length, a), e;
}
function fo(e, t, n) {
  const r = this;
  let i = r.events.length, o, l;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return a;
  function a(p) {
    return o ? o._inactive ? c(p) : (l = r.parser.defined.includes(ce(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(p);
  }
  function u(p) {
    return p === 40 ? e.attempt(oo, f, l ? f : c)(p) : p === 91 ? e.attempt(ao, f, l ? s : c)(p) : l ? f(p) : c(p);
  }
  function s(p) {
    return e.attempt(uo, f, c)(p);
  }
  function f(p) {
    return t(p);
  }
  function c(p) {
    return o._balanced = !0, n(p);
  }
}
function ho(e, t, n) {
  return r;
  function r(c) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), i;
  }
  function i(c) {
    return U(c) ? $e(e, o)(c) : o(c);
  }
  function o(c) {
    return c === 41 ? f(c) : dr(e, l, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(c);
  }
  function l(c) {
    return U(c) ? $e(e, u)(c) : f(c);
  }
  function a(c) {
    return n(c);
  }
  function u(c) {
    return c === 34 || c === 39 || c === 40 ? yr(e, s, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(c) : f(c);
  }
  function s(c) {
    return U(c) ? $e(e, f)(c) : f(c);
  }
  function f(c) {
    return c === 41 ? (e.enter("resourceMarker"), e.consume(c), e.exit("resourceMarker"), e.exit("resource"), t) : n(c);
  }
}
function po(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return xr.call(r, e, o, l, "reference", "referenceMarker", "referenceString")(a);
  }
  function o(a) {
    return r.parser.defined.includes(ce(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(a) : n(a);
  }
  function l(a) {
    return n(a);
  }
}
function mo(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const go = {
  name: "labelStartImage",
  tokenize: xo,
  resolveAll: Un.resolveAll
};
function xo(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), o;
  }
  function o(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), l) : n(a);
  }
  function l(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const yo = {
  name: "labelStartLink",
  tokenize: ko,
  resolveAll: Un.resolveAll
};
function ko(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(l) {
    return l === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(l) : t(l);
  }
}
const pn = {
  name: "lineEnding",
  tokenize: bo
};
function bo(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), B(e, t, "linePrefix");
  }
}
const Ke = {
  name: "thematicBreak",
  tokenize: wo
};
function wo(e, t, n) {
  let r = 0, i;
  return o;
  function o(s) {
    return e.enter("thematicBreak"), l(s);
  }
  function l(s) {
    return i = s, a(s);
  }
  function a(s) {
    return s === i ? (e.enter("thematicBreakSequence"), u(s)) : r >= 3 && (s === null || F(s)) ? (e.exit("thematicBreak"), t(s)) : n(s);
  }
  function u(s) {
    return s === i ? (e.consume(s), r++, u) : (e.exit("thematicBreakSequence"), j(s) ? B(e, a, "whitespace")(s) : a(s));
  }
}
const ee = {
  name: "list",
  tokenize: Eo,
  continuation: {
    tokenize: Io
  },
  exit: Ao
}, So = {
  tokenize: Fo,
  partial: !0
}, Co = {
  tokenize: To,
  partial: !0
};
function Eo(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, l = 0;
  return a;
  function a(h) {
    const d = r.containerState.type || (h === 42 || h === 43 || h === 45 ? "listUnordered" : "listOrdered");
    if (d === "listUnordered" ? !r.containerState.marker || h === r.containerState.marker : Pn(h)) {
      if (r.containerState.type || (r.containerState.type = d, e.enter(d, {
        _container: !0
      })), d === "listUnordered")
        return e.enter("listItemPrefix"), h === 42 || h === 45 ? e.check(Ke, n, s)(h) : s(h);
      if (!r.interrupt || h === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(h);
    }
    return n(h);
  }
  function u(h) {
    return Pn(h) && ++l < 10 ? (e.consume(h), u) : (!r.interrupt || l < 2) && (r.containerState.marker ? h === r.containerState.marker : h === 41 || h === 46) ? (e.exit("listItemValue"), s(h)) : n(h);
  }
  function s(h) {
    return e.enter("listItemMarker"), e.consume(h), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || h, e.check(
      Ue,
      // Can’t be empty when interrupting.
      r.interrupt ? n : f,
      e.attempt(So, p, c)
    );
  }
  function f(h) {
    return r.containerState.initialBlankLine = !0, o++, p(h);
  }
  function c(h) {
    return j(h) ? (e.enter("listItemPrefixWhitespace"), e.consume(h), e.exit("listItemPrefixWhitespace"), p) : n(h);
  }
  function p(h) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(h);
  }
}
function Io(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ue, i, o);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, B(e, t, "listItemIndent", r.containerState.size + 1)(a);
  }
  function o(a) {
    return r.containerState.furtherBlankLines || !j(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, l(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(Co, t, l)(a));
  }
  function l(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, B(e, e.attempt(ee, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function To(e, t, n) {
  const r = this;
  return B(e, i, "listItemIndent", r.containerState.size + 1);
  function i(o) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "listItemIndent" && l[2].sliceSerialize(l[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function Ao(e) {
  e.exit(this.containerState.type);
}
function Fo(e, t, n) {
  const r = this;
  return B(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const l = r.events[r.events.length - 1];
    return !j(o) && l && l[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const St = {
  name: "setextUnderline",
  tokenize: vo,
  resolveTo: Po
};
function Po(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const l = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", l, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = l, e.push(["exit", l, t]), e;
}
function vo(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(s) {
    let f = r.events.length, c;
    for (; f--; )
      if (r.events[f][1].type !== "lineEnding" && r.events[f][1].type !== "linePrefix" && r.events[f][1].type !== "content") {
        c = r.events[f][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || c) ? (e.enter("setextHeadingLine"), i = s, l(s)) : n(s);
  }
  function l(s) {
    return e.enter("setextHeadingLineSequence"), a(s);
  }
  function a(s) {
    return s === i ? (e.consume(s), a) : (e.exit("setextHeadingLineSequence"), j(s) ? B(e, u, "lineSuffix")(s) : u(s));
  }
  function u(s) {
    return s === null || F(s) ? (e.exit("setextHeadingLine"), t(s)) : n(s);
  }
}
const zo = {
  tokenize: Lo
};
function Lo(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Ue,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      B(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(Rl, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const Do = {
  resolveAll: br()
}, Oo = kr("string"), Mo = kr("text");
function kr(e) {
  return {
    tokenize: t,
    resolveAll: br(
      e === "text" ? Ro : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, l, a);
    return l;
    function l(f) {
      return s(f) ? o(f) : a(f);
    }
    function a(f) {
      if (f === null) {
        n.consume(f);
        return;
      }
      return n.enter("data"), n.consume(f), u;
    }
    function u(f) {
      return s(f) ? (n.exit("data"), o(f)) : (n.consume(f), u);
    }
    function s(f) {
      if (f === null)
        return !0;
      const c = i[f];
      let p = -1;
      if (c)
        for (; ++p < c.length; ) {
          const h = c[p];
          if (!h.previous || h.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function br(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function Ro(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, l = -1, a = 0, u;
      for (; o--; ) {
        const s = i[o];
        if (typeof s == "string") {
          for (l = s.length; s.charCodeAt(l - 1) === 32; )
            a++, l--;
          if (l) break;
          l = -1;
        } else if (s === -2)
          u = !0, a++;
        else if (s !== -1) {
          o++;
          break;
        }
      }
      if (a) {
        const s = {
          type: n === e.length || u || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a,
            _index: r.start._index + o,
            _bufferIndex: o ? l : r.start._bufferIndex + l
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, s.start), r.start.offset === r.end.offset ? Object.assign(r, s) : (e.splice(
          n,
          0,
          ["enter", s, t],
          ["exit", s, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function _o(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let l = [], a = [];
  const u = {
    consume: y,
    enter: E,
    exit: L,
    attempt: O(D),
    check: O(S),
    interrupt: O(S, {
      interrupt: !0
    })
  }, s = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: h,
    sliceSerialize: p,
    now: d,
    defineSkip: x,
    write: c
  };
  let f = t.tokenize.call(s, u);
  return t.resolveAll && o.push(t), s;
  function c(P) {
    return l = re(l, P), C(), l[l.length - 1] !== null ? [] : (q(t, 0), s.events = ln(o, s.events, s), s.events);
  }
  function p(P, v) {
    return Bo(h(P), v);
  }
  function h(P) {
    return No(l, P);
  }
  function d() {
    const { line: P, column: v, offset: z, _index: A, _bufferIndex: M } = r;
    return {
      line: P,
      column: v,
      offset: z,
      _index: A,
      _bufferIndex: M
    };
  }
  function x(P) {
    i[P.line] = P.column, k();
  }
  function C() {
    let P;
    for (; r._index < l.length; ) {
      const v = l[r._index];
      if (typeof v == "string")
        for (P = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === P && r._bufferIndex < v.length; )
          b(v.charCodeAt(r._bufferIndex));
      else
        b(v);
    }
  }
  function b(P) {
    f = f(P);
  }
  function y(P) {
    F(P) ? (r.line++, r.column = 1, r.offset += P === -3 ? 2 : 1, k()) : P !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === l[r._index].length && (r._bufferIndex = -1, r._index++)), s.previous = P;
  }
  function E(P, v) {
    const z = v || {};
    return z.type = P, z.start = d(), s.events.push(["enter", z, s]), a.push(z), z;
  }
  function L(P) {
    const v = a.pop();
    return v.end = d(), s.events.push(["exit", v, s]), v;
  }
  function D(P, v) {
    q(P, v.from);
  }
  function S(P, v) {
    v.restore();
  }
  function O(P, v) {
    return z;
    function z(A, M, Q) {
      let Y, oe, pe, m;
      return Array.isArray(A) ? me(A) : "tokenize" in A ? (
        // @ts-expect-error Looks like a construct.
        me([A])
      ) : ae(A);
      function ae(X) {
        return Me;
        function Me(ye) {
          const Te = ye !== null && X[ye], Ae = ye !== null && X.null, We = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Te) ? Te : Te ? [Te] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return me(We)(ye);
        }
      }
      function me(X) {
        return Y = X, oe = 0, X.length === 0 ? Q : g(X[oe]);
      }
      function g(X) {
        return Me;
        function Me(ye) {
          return m = R(), pe = X, X.partial || (s.currentConstruct = X), X.name && s.parser.constructs.disable.null.includes(X.name) ? we() : X.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            v ? Object.assign(Object.create(s), v) : s,
            u,
            ue,
            we
          )(ye);
        }
      }
      function ue(X) {
        return P(pe, m), M;
      }
      function we(X) {
        return m.restore(), ++oe < Y.length ? g(Y[oe]) : Q;
      }
    }
  }
  function q(P, v) {
    P.resolveAll && !o.includes(P) && o.push(P), P.resolve && ie(
      s.events,
      v,
      s.events.length - v,
      P.resolve(s.events.slice(v), s)
    ), P.resolveTo && (s.events = P.resolveTo(s.events, s));
  }
  function R() {
    const P = d(), v = s.previous, z = s.currentConstruct, A = s.events.length, M = Array.from(a);
    return {
      restore: Q,
      from: A
    };
    function Q() {
      r = P, s.previous = v, s.currentConstruct = z, s.events.length = A, a = M, k();
    }
  }
  function k() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function No(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let l;
  if (n === i)
    l = [e[n].slice(r, o)];
  else {
    if (l = e.slice(n, i), r > -1) {
      const a = l[0];
      typeof a == "string" ? l[0] = a.slice(r) : l.shift();
    }
    o > 0 && l.push(e[i].slice(0, o));
  }
  return l;
}
function Bo(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let l;
    if (typeof o == "string")
      l = o;
    else
      switch (o) {
        case -5: {
          l = "\r";
          break;
        }
        case -4: {
          l = `
`;
          break;
        }
        case -3: {
          l = `\r
`;
          break;
        }
        case -2: {
          l = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i) continue;
          l = " ";
          break;
        }
        default:
          l = String.fromCharCode(o);
      }
    i = o === -2, r.push(l);
  }
  return r.join("");
}
const jo = {
  42: ee,
  43: ee,
  45: ee,
  48: ee,
  49: ee,
  50: ee,
  51: ee,
  52: ee,
  53: ee,
  54: ee,
  55: ee,
  56: ee,
  57: ee,
  62: hr
}, $o = {
  91: $l
}, qo = {
  [-2]: hn,
  [-1]: hn,
  32: hn
}, Ho = {
  35: Ql,
  42: Ke,
  45: [St, Ke],
  60: Kl,
  61: St,
  95: Ke,
  96: bt,
  126: bt
}, Uo = {
  38: mr,
  92: pr
}, Vo = {
  [-5]: pn,
  [-4]: pn,
  [-3]: pn,
  33: go,
  38: mr,
  42: vn,
  60: [xl, io],
  91: yo,
  92: [Vl, pr],
  93: Un,
  95: vn,
  96: vl
}, Wo = {
  null: [vn, Do]
}, Qo = {
  null: [42, 95]
}, Yo = {
  null: []
}, Xo = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Qo,
  contentInitial: $o,
  disable: Yo,
  document: jo,
  flow: Ho,
  flowInitial: qo,
  insideSpan: Wo,
  string: Uo,
  text: Vo
}, Symbol.toStringTag, { value: "Module" }));
function Go(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    cr([Xo, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(cl),
    document: i(hl),
    flow: i(zo),
    string: i(Oo),
    text: i(Mo)
  };
  return r;
  function i(o) {
    return l;
    function l(a) {
      return _o(r, o, a);
    }
  }
}
function Ko(e) {
  for (; !gr(e); )
    ;
  return e;
}
const Ct = /[\0\t\n\r]/g;
function Jo() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, l, a) {
    const u = [];
    let s, f, c, p, h;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(l || void 0).decode(o)), c = 0, t = "", n && (o.charCodeAt(0) === 65279 && c++, n = void 0); c < o.length; ) {
      if (Ct.lastIndex = c, s = Ct.exec(o), p = s && s.index !== void 0 ? s.index : o.length, h = o.charCodeAt(p), !s) {
        t = o.slice(c);
        break;
      }
      if (h === 10 && c === p && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), c < p && (u.push(o.slice(c, p)), e += p - c), h) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (f = Math.ceil(e / 4) * 4, u.push(-2); e++ < f; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      c = p + 1;
    }
    return a && (r && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const Zo = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ea(e) {
  return e.replace(Zo, na);
}
function na(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return fr(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Hn(n) || e;
}
const wr = {}.hasOwnProperty;
function ta(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), ra(n)(Ko(Go(n).document().write(Jo()(e, t, !0))));
}
function ra(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(rt),
      autolinkProtocol: R,
      autolinkEmail: R,
      atxHeading: o(et),
      blockQuote: o(Ae),
      characterEscape: R,
      characterReference: R,
      codeFenced: o(We),
      codeFencedFenceInfo: l,
      codeFencedFenceMeta: l,
      codeIndented: o(We, l),
      codeText: o(ei, l),
      codeTextData: R,
      data: R,
      codeFlowValue: R,
      definition: o(ni),
      definitionDestinationString: l,
      definitionLabelString: l,
      definitionTitleString: l,
      emphasis: o(ti),
      hardBreakEscape: o(nt),
      hardBreakTrailing: o(nt),
      htmlFlow: o(tt, l),
      htmlFlowData: R,
      htmlText: o(tt, l),
      htmlTextData: R,
      image: o(ri),
      label: l,
      link: o(rt),
      listItem: o(ii),
      listItemValue: p,
      listOrdered: o(it, c),
      listUnordered: o(it),
      paragraph: o(li),
      reference: g,
      referenceString: l,
      resourceDestinationString: l,
      resourceTitleString: l,
      setextHeading: o(et),
      strong: o(oi),
      thematicBreak: o(ui)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: D,
      autolink: u(),
      autolinkEmail: Te,
      autolinkProtocol: ye,
      blockQuote: u(),
      characterEscapeValue: k,
      characterReferenceMarkerHexadecimal: we,
      characterReferenceMarkerNumeric: we,
      characterReferenceValue: X,
      characterReference: Me,
      codeFenced: u(C),
      codeFencedFence: x,
      codeFencedFenceInfo: h,
      codeFencedFenceMeta: d,
      codeFlowValue: k,
      codeIndented: u(b),
      codeText: u(M),
      codeTextData: k,
      data: k,
      definition: u(),
      definitionDestinationString: L,
      definitionLabelString: y,
      definitionTitleString: E,
      emphasis: u(),
      hardBreakEscape: u(v),
      hardBreakTrailing: u(v),
      htmlFlow: u(z),
      htmlFlowData: k,
      htmlText: u(A),
      htmlTextData: k,
      image: u(Y),
      label: pe,
      labelText: oe,
      lineEnding: P,
      link: u(Q),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: ue,
      resourceDestinationString: m,
      resourceTitleString: ae,
      resource: me,
      setextHeading: u(q),
      setextHeadingLineSequence: O,
      setextHeadingText: S,
      strong: u(),
      thematicBreak: u()
    }
  };
  Sr(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(w) {
    let T = {
      type: "root",
      children: []
    };
    const _ = {
      stack: [T],
      tokenStack: [],
      config: t,
      enter: a,
      exit: s,
      buffer: l,
      resume: f,
      data: n
    }, $ = [];
    let H = -1;
    for (; ++H < w.length; )
      if (w[H][1].type === "listOrdered" || w[H][1].type === "listUnordered")
        if (w[H][0] === "enter")
          $.push(H);
        else {
          const se = $.pop();
          H = i(w, se, H);
        }
    for (H = -1; ++H < w.length; ) {
      const se = t[w[H][0]];
      wr.call(se, w[H][1].type) && se[w[H][1].type].call(Object.assign({
        sliceSerialize: w[H][2].sliceSerialize
      }, _), w[H][1]);
    }
    if (_.tokenStack.length > 0) {
      const se = _.tokenStack[_.tokenStack.length - 1];
      (se[1] || Et).call(_, void 0, se[0]);
    }
    for (T.position = {
      start: ke(w.length > 0 ? w[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: ke(w.length > 0 ? w[w.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, H = -1; ++H < t.transforms.length; )
      T = t.transforms[H](T) || T;
    return T;
  }
  function i(w, T, _) {
    let $ = T - 1, H = -1, se = !1, Se, ge, Re, _e;
    for (; ++$ <= _; ) {
      const ne = w[$];
      switch (ne[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          ne[0] === "enter" ? H++ : H--, _e = void 0;
          break;
        }
        case "lineEndingBlank": {
          ne[0] === "enter" && (Se && !_e && !H && !Re && (Re = $), _e = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          _e = void 0;
      }
      if (!H && ne[0] === "enter" && ne[1].type === "listItemPrefix" || H === -1 && ne[0] === "exit" && (ne[1].type === "listUnordered" || ne[1].type === "listOrdered")) {
        if (Se) {
          let Fe = $;
          for (ge = void 0; Fe--; ) {
            const de = w[Fe];
            if (de[1].type === "lineEnding" || de[1].type === "lineEndingBlank") {
              if (de[0] === "exit") continue;
              ge && (w[ge][1].type = "lineEndingBlank", se = !0), de[1].type = "lineEnding", ge = Fe;
            } else if (!(de[1].type === "linePrefix" || de[1].type === "blockQuotePrefix" || de[1].type === "blockQuotePrefixWhitespace" || de[1].type === "blockQuoteMarker" || de[1].type === "listItemIndent")) break;
          }
          Re && (!ge || Re < ge) && (Se._spread = !0), Se.end = Object.assign({}, ge ? w[ge][1].start : ne[1].end), w.splice(ge || $, 0, ["exit", Se, ne[2]]), $++, _++;
        }
        if (ne[1].type === "listItemPrefix") {
          const Fe = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, ne[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Se = Fe, w.splice($, 0, ["enter", Fe, ne[2]]), $++, _++, Re = void 0, _e = !0;
        }
      }
    }
    return w[T][1]._spread = se, _;
  }
  function o(w, T) {
    return _;
    function _($) {
      a.call(this, w($), $), T && T.call(this, $);
    }
  }
  function l() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(w, T, _) {
    this.stack[this.stack.length - 1].children.push(w), this.stack.push(w), this.tokenStack.push([T, _]), w.position = {
      start: ke(T.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(w) {
    return T;
    function T(_) {
      w && w.call(this, _), s.call(this, _);
    }
  }
  function s(w, T) {
    const _ = this.stack.pop(), $ = this.tokenStack.pop();
    if ($)
      $[0].type !== w.type && (T ? T.call(this, w, $[0]) : ($[1] || Et).call(this, w, $[0]));
    else throw new Error("Cannot close `" + w.type + "` (" + je({
      start: w.start,
      end: w.end
    }) + "): it’s not open");
    _.position.end = ke(w.end);
  }
  function f() {
    return qn(this.stack.pop());
  }
  function c() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p(w) {
    if (this.data.expectingFirstListItemValue) {
      const T = this.stack[this.stack.length - 2];
      T.start = Number.parseInt(this.sliceSerialize(w), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function h() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.lang = w;
  }
  function d() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.meta = w;
  }
  function x() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.value = w.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function b() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.value = w.replace(/(\r?\n|\r)$/g, "");
  }
  function y(w) {
    const T = this.resume(), _ = this.stack[this.stack.length - 1];
    _.label = T, _.identifier = ce(this.sliceSerialize(w)).toLowerCase();
  }
  function E() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.title = w;
  }
  function L() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.url = w;
  }
  function D(w) {
    const T = this.stack[this.stack.length - 1];
    if (!T.depth) {
      const _ = this.sliceSerialize(w).length;
      T.depth = _;
    }
  }
  function S() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(w) {
    const T = this.stack[this.stack.length - 1];
    T.depth = this.sliceSerialize(w).codePointAt(0) === 61 ? 1 : 2;
  }
  function q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function R(w) {
    const _ = this.stack[this.stack.length - 1].children;
    let $ = _[_.length - 1];
    (!$ || $.type !== "text") && ($ = ai(), $.position = {
      start: ke(w.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, _.push($)), this.stack.push($);
  }
  function k(w) {
    const T = this.stack.pop();
    T.value += this.sliceSerialize(w), T.position.end = ke(w.end);
  }
  function P(w) {
    const T = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const _ = T.children[T.children.length - 1];
      _.position.end = ke(w.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(T.type) && (R.call(this, w), k.call(this, w));
  }
  function v() {
    this.data.atHardBreak = !0;
  }
  function z() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.value = w;
  }
  function A() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.value = w;
  }
  function M() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.value = w;
  }
  function Q() {
    const w = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const T = this.data.referenceType || "shortcut";
      w.type += "Reference", w.referenceType = T, delete w.url, delete w.title;
    } else
      delete w.identifier, delete w.label;
    this.data.referenceType = void 0;
  }
  function Y() {
    const w = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const T = this.data.referenceType || "shortcut";
      w.type += "Reference", w.referenceType = T, delete w.url, delete w.title;
    } else
      delete w.identifier, delete w.label;
    this.data.referenceType = void 0;
  }
  function oe(w) {
    const T = this.sliceSerialize(w), _ = this.stack[this.stack.length - 2];
    _.label = ea(T), _.identifier = ce(T).toLowerCase();
  }
  function pe() {
    const w = this.stack[this.stack.length - 1], T = this.resume(), _ = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, _.type === "link") {
      const $ = w.children;
      _.children = $;
    } else
      _.alt = T;
  }
  function m() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.url = w;
  }
  function ae() {
    const w = this.resume(), T = this.stack[this.stack.length - 1];
    T.title = w;
  }
  function me() {
    this.data.inReference = void 0;
  }
  function g() {
    this.data.referenceType = "collapsed";
  }
  function ue(w) {
    const T = this.resume(), _ = this.stack[this.stack.length - 1];
    _.label = T, _.identifier = ce(this.sliceSerialize(w)).toLowerCase(), this.data.referenceType = "full";
  }
  function we(w) {
    this.data.characterReferenceType = w.type;
  }
  function X(w) {
    const T = this.sliceSerialize(w), _ = this.data.characterReferenceType;
    let $;
    _ ? ($ = fr(T, _ === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : $ = Hn(T);
    const H = this.stack[this.stack.length - 1];
    H.value += $;
  }
  function Me(w) {
    const T = this.stack.pop();
    T.position.end = ke(w.end);
  }
  function ye(w) {
    k.call(this, w);
    const T = this.stack[this.stack.length - 1];
    T.url = this.sliceSerialize(w);
  }
  function Te(w) {
    k.call(this, w);
    const T = this.stack[this.stack.length - 1];
    T.url = "mailto:" + this.sliceSerialize(w);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function We() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ei() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ni() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ti() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function et() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function nt() {
    return {
      type: "break"
    };
  }
  function tt() {
    return {
      type: "html",
      value: ""
    };
  }
  function ri() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function rt() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function it(w) {
    return {
      type: "list",
      ordered: w.type === "listOrdered",
      start: null,
      spread: w._spread,
      children: []
    };
  }
  function ii(w) {
    return {
      type: "listItem",
      spread: w._spread,
      checked: null,
      children: []
    };
  }
  function li() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function oi() {
    return {
      type: "strong",
      children: []
    };
  }
  function ai() {
    return {
      type: "text",
      value: ""
    };
  }
  function ui() {
    return {
      type: "thematicBreak"
    };
  }
}
function ke(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Sr(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Sr(e, r) : ia(e, r);
  }
}
function ia(e, t) {
  let n;
  for (n in t)
    if (wr.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Et(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + je({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + je({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + je({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function la(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return ta(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function oa(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function aa(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function ua(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function sa(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ca(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function fa(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = Oe(r.toLowerCase()), o = e.footnoteOrder.indexOf(r);
  let l, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), l = e.footnoteOrder.length) : l = o + 1, a += 1, e.footnoteCounts.set(r, a);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(l) }]
  };
  e.patch(t, u);
  const s = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, s), e.applyData(t, s);
}
function ha(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function pa(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Cr(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const l = i[i.length - 1];
  return l && l.type === "text" ? l.value += r : i.push({ type: "text", value: r }), i;
}
function ma(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Cr(e, t);
  const i = { src: Oe(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function ga(e, t) {
  const n = { src: Oe(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function da(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function xa(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Cr(e, t);
  const i = { href: Oe(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function ya(e, t) {
  const n = { href: Oe(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function ka(e, t, n) {
  const r = e.all(t), i = n ? ba(n) : Er(t), o = {}, l = [];
  if (typeof t.checked == "boolean") {
    const f = r[0];
    let c;
    f && f.type === "element" && f.tagName === "p" ? c = f : (c = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(c)), c.children.length > 0 && c.children.unshift({ type: "text", value: " " }), c.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const f = r[a];
    (i || a !== 0 || f.type !== "element" || f.tagName !== "p") && l.push({ type: "text", value: `
` }), f.type === "element" && f.tagName === "p" && !i ? l.push(...f.children) : l.push(f);
  }
  const u = r[r.length - 1];
  u && (i || u.type !== "element" || u.tagName !== "p") && l.push({ type: "text", value: `
` });
  const s = { type: "element", tagName: "li", properties: o, children: l };
  return e.patch(t, s), e.applyData(t, s);
}
function ba(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Er(n[r]);
  }
  return t;
}
function Er(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function wa(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const l = r[i];
    if (l.type === "element" && l.tagName === "li" && l.properties && Array.isArray(l.properties.className) && l.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function Sa(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Ca(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Ea(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Ia(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const l = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], l), i.push(l);
  }
  if (n.length > 0) {
    const l = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, a = Nn(t.children[1]), u = rr(t.children[t.children.length - 1]);
    a && u && (l.position = { start: a, end: u }), i.push(l);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function Ta(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", l = n && n.type === "table" ? n.align : void 0, a = l ? l.length : t.children.length;
  let u = -1;
  const s = [];
  for (; ++u < a; ) {
    const c = t.children[u], p = {}, h = l ? l[u] : void 0;
    h && (p.align = h);
    let d = { type: "element", tagName: o, properties: p, children: [] };
    c && (d.children = e.all(c), e.patch(c, d), d = e.applyData(c, d)), s.push(d);
  }
  const f = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(s, !0)
  };
  return e.patch(t, f), e.applyData(t, f);
}
function Aa(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const It = 9, Tt = 32;
function Fa(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      At(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(At(t.slice(i), i > 0, !1)), o.join("");
}
function At(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === It || o === Tt; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === It || o === Tt; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function Pa(e, t) {
  const n = { type: "text", value: Fa(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function va(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const za = {
  blockquote: oa,
  break: aa,
  code: ua,
  delete: sa,
  emphasis: ca,
  footnoteReference: fa,
  heading: ha,
  html: pa,
  imageReference: ma,
  image: ga,
  inlineCode: da,
  linkReference: xa,
  link: ya,
  listItem: ka,
  list: wa,
  paragraph: Sa,
  // @ts-expect-error: root is different, but hard to type.
  root: Ca,
  strong: Ea,
  table: Ia,
  tableCell: Aa,
  tableRow: Ta,
  text: Pa,
  thematicBreak: va,
  toml: Qe,
  yaml: Qe,
  definition: Qe,
  footnoteDefinition: Qe
};
function Qe() {
}
const Ir = -1, on = 0, en = 1, nn = 2, Vn = 3, Wn = 4, Qn = 5, Yn = 6, Tr = 7, Ar = 8, Ft = typeof self == "object" ? self : globalThis, La = (e, t) => {
  const n = (i, o) => (e.set(o, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [o, l] = t[i];
    switch (o) {
      case on:
      case Ir:
        return n(l, i);
      case en: {
        const a = n([], i);
        for (const u of l)
          a.push(r(u));
        return a;
      }
      case nn: {
        const a = n({}, i);
        for (const [u, s] of l)
          a[r(u)] = r(s);
        return a;
      }
      case Vn:
        return n(new Date(l), i);
      case Wn: {
        const { source: a, flags: u } = l;
        return n(new RegExp(a, u), i);
      }
      case Qn: {
        const a = n(/* @__PURE__ */ new Map(), i);
        for (const [u, s] of l)
          a.set(r(u), r(s));
        return a;
      }
      case Yn: {
        const a = n(/* @__PURE__ */ new Set(), i);
        for (const u of l)
          a.add(r(u));
        return a;
      }
      case Tr: {
        const { name: a, message: u } = l;
        return n(new Ft[a](u), i);
      }
      case Ar:
        return n(BigInt(l), i);
      case "BigInt":
        return n(Object(BigInt(l)), i);
    }
    return n(new Ft[o](l), i);
  };
  return r;
}, Pt = (e) => La(/* @__PURE__ */ new Map(), e)(0), ve = "", { toString: Da } = {}, { keys: Oa } = Object, Be = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [on, t];
  const n = Da.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [en, ve];
    case "Object":
      return [nn, ve];
    case "Date":
      return [Vn, ve];
    case "RegExp":
      return [Wn, ve];
    case "Map":
      return [Qn, ve];
    case "Set":
      return [Yn, ve];
  }
  return n.includes("Array") ? [en, n] : n.includes("Error") ? [Tr, n] : [nn, n];
}, Ye = ([e, t]) => e === on && (t === "function" || t === "symbol"), Ma = (e, t, n, r) => {
  const i = (l, a) => {
    const u = r.push(l) - 1;
    return n.set(a, u), u;
  }, o = (l) => {
    if (n.has(l))
      return n.get(l);
    let [a, u] = Be(l);
    switch (a) {
      case on: {
        let f = l;
        switch (u) {
          case "bigint":
            a = Ar, f = l.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            f = null;
            break;
          case "undefined":
            return i([Ir], l);
        }
        return i([a, f], l);
      }
      case en: {
        if (u)
          return i([u, [...l]], l);
        const f = [], c = i([a, f], l);
        for (const p of l)
          f.push(o(p));
        return c;
      }
      case nn: {
        if (u)
          switch (u) {
            case "BigInt":
              return i([u, l.toString()], l);
            case "Boolean":
            case "Number":
            case "String":
              return i([u, l.valueOf()], l);
          }
        if (t && "toJSON" in l)
          return o(l.toJSON());
        const f = [], c = i([a, f], l);
        for (const p of Oa(l))
          (e || !Ye(Be(l[p]))) && f.push([o(p), o(l[p])]);
        return c;
      }
      case Vn:
        return i([a, l.toISOString()], l);
      case Wn: {
        const { source: f, flags: c } = l;
        return i([a, { source: f, flags: c }], l);
      }
      case Qn: {
        const f = [], c = i([a, f], l);
        for (const [p, h] of l)
          (e || !(Ye(Be(p)) || Ye(Be(h)))) && f.push([o(p), o(h)]);
        return c;
      }
      case Yn: {
        const f = [], c = i([a, f], l);
        for (const p of l)
          (e || !Ye(Be(p))) && f.push(o(p));
        return c;
      }
    }
    const { message: s } = l;
    return i([a, { name: u, message: s }], l);
  };
  return o;
}, vt = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return Ma(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, tn = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? Pt(vt(e, t)) : structuredClone(e)
) : (e, t) => Pt(vt(e, t));
function Ra(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function _a(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function Na(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || Ra, r = e.options.footnoteBackLabel || _a, i = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", l = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const s = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!s)
      continue;
    const f = e.all(s), c = String(s.identifier).toUpperCase(), p = Oe(c.toLowerCase());
    let h = 0;
    const d = [], x = e.footnoteCounts.get(c);
    for (; x !== void 0 && ++h <= x; ) {
      d.length > 0 && d.push({ type: "text", value: " " });
      let y = typeof n == "string" ? n : n(u, h);
      typeof y == "string" && (y = { type: "text", value: y }), d.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + p + (h > 1 ? "-" + h : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, h),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const C = f[f.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const y = C.children[C.children.length - 1];
      y && y.type === "text" ? y.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...d);
    } else
      f.push(...d);
    const b = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + p },
      children: e.wrap(f, !0)
    };
    e.patch(s, b), a.push(b);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...tn(l),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const an = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return qa;
    if (typeof e == "function")
      return un(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Ba(e) : ja(e);
    if (typeof e == "string")
      return $a(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Ba(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = an(e[n]);
  return un(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i)) return !0;
    return !1;
  }
}
function ja(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return un(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o]) return !1;
    return !0;
  }
}
function $a(e) {
  return un(t);
  function t(n) {
    return n && n.type === e;
  }
}
function un(e) {
  return t;
  function t(n, r, i) {
    return !!(Ha(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function qa() {
  return !0;
}
function Ha(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Fr = [], Ua = !0, zn = !1, Va = "skip";
function Pr(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = an(i), l = r ? -1 : 1;
  a(e, void 0, [])();
  function a(u, s, f) {
    const c = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof c.type == "string") {
      const h = (
        // `hast`
        typeof c.tagName == "string" ? c.tagName : (
          // `xast`
          typeof c.name == "string" ? c.name : void 0
        )
      );
      Object.defineProperty(p, "name", {
        value: "node (" + (u.type + (h ? "<" + h + ">" : "")) + ")"
      });
    }
    return p;
    function p() {
      let h = Fr, d, x, C;
      if ((!t || o(u, s, f[f.length - 1] || void 0)) && (h = Wa(n(u, f)), h[0] === zn))
        return h;
      if ("children" in u && u.children) {
        const b = (
          /** @type {UnistParent} */
          u
        );
        if (b.children && h[0] !== Va)
          for (x = (r ? b.children.length : -1) + l, C = f.concat(b); x > -1 && x < b.children.length; ) {
            const y = b.children[x];
            if (d = a(y, x, C)(), d[0] === zn)
              return d;
            x = typeof d[1] == "number" ? d[1] : x + l;
          }
      }
      return h;
    }
  }
}
function Wa(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Ua, e] : e == null ? Fr : [e];
}
function Xn(e, t, n, r) {
  let i, o, l;
  typeof t == "function" && typeof n != "function" ? (o = void 0, l = t, i = n) : (o = t, l = n, i = r), Pr(e, o, a, i);
  function a(u, s) {
    const f = s[s.length - 1], c = f ? f.children.indexOf(u) : void 0;
    return l(u, c, f);
  }
}
const Ln = {}.hasOwnProperty, Qa = {};
function Ya(e, t) {
  const n = t || Qa, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), l = { ...za, ...n.handlers }, a = {
    all: s,
    applyData: Ga,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: l,
    one: u,
    options: n,
    patch: Xa,
    wrap: Ja
  };
  return Xn(e, function(f) {
    if (f.type === "definition" || f.type === "footnoteDefinition") {
      const c = f.type === "definition" ? r : i, p = String(f.identifier).toUpperCase();
      c.has(p) || c.set(p, f);
    }
  }), a;
  function u(f, c) {
    const p = f.type, h = a.handlers[p];
    if (Ln.call(a.handlers, p) && h)
      return h(a, f, c);
    if (a.options.passThrough && a.options.passThrough.includes(p)) {
      if ("children" in f) {
        const { children: x, ...C } = f, b = tn(C);
        return b.children = a.all(f), b;
      }
      return tn(f);
    }
    return (a.options.unknownHandler || Ka)(a, f, c);
  }
  function s(f) {
    const c = [];
    if ("children" in f) {
      const p = f.children;
      let h = -1;
      for (; ++h < p.length; ) {
        const d = a.one(p[h], f);
        if (d) {
          if (h && p[h - 1].type === "break" && (!Array.isArray(d) && d.type === "text" && (d.value = zt(d.value)), !Array.isArray(d) && d.type === "element")) {
            const x = d.children[0];
            x && x.type === "text" && (x.value = zt(x.value));
          }
          Array.isArray(d) ? c.push(...d) : c.push(d);
        }
      }
    }
    return c;
  }
}
function Xa(e, t) {
  e.position && (t.position = Oi(e));
}
function Ga(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const l = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: l };
      }
    n.type === "element" && o && Object.assign(n.properties, tn(o)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function Ka(e, t) {
  const n = t.data || {}, r = "value" in t && !(Ln.call(n, "hProperties") || Ln.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Ja(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function zt(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function Lt(e, t) {
  const n = Ya(e, t), r = n.one(e, void 0), i = Na(n), o = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && o.children.push({ type: "text", value: `
` }, i), o;
}
function Za(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      Lt(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      Lt(n, { file: r, ...t || e })
    );
  };
}
function Dt(e) {
  if (e)
    throw e;
}
var mn, Ot;
function eu() {
  if (Ot) return mn;
  Ot = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, i = function(s) {
    return typeof Array.isArray == "function" ? Array.isArray(s) : t.call(s) === "[object Array]";
  }, o = function(s) {
    if (!s || t.call(s) !== "[object Object]")
      return !1;
    var f = e.call(s, "constructor"), c = s.constructor && s.constructor.prototype && e.call(s.constructor.prototype, "isPrototypeOf");
    if (s.constructor && !f && !c)
      return !1;
    var p;
    for (p in s)
      ;
    return typeof p > "u" || e.call(s, p);
  }, l = function(s, f) {
    n && f.name === "__proto__" ? n(s, f.name, {
      enumerable: !0,
      configurable: !0,
      value: f.newValue,
      writable: !0
    }) : s[f.name] = f.newValue;
  }, a = function(s, f) {
    if (f === "__proto__")
      if (e.call(s, f)) {
        if (r)
          return r(s, f).value;
      } else return;
    return s[f];
  };
  return mn = function u() {
    var s, f, c, p, h, d, x = arguments[0], C = 1, b = arguments.length, y = !1;
    for (typeof x == "boolean" && (y = x, x = arguments[1] || {}, C = 2), (x == null || typeof x != "object" && typeof x != "function") && (x = {}); C < b; ++C)
      if (s = arguments[C], s != null)
        for (f in s)
          c = a(x, f), p = a(s, f), x !== p && (y && p && (o(p) || (h = i(p))) ? (h ? (h = !1, d = c && i(c) ? c : []) : d = c && o(c) ? c : {}, l(x, { name: f, newValue: u(y, d, p) })) : typeof p < "u" && l(x, { name: f, newValue: p }));
    return x;
  }, mn;
}
var nu = eu();
const gn = /* @__PURE__ */ Yt(nu);
function Dn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function tu() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const l = i.pop();
    if (typeof l != "function")
      throw new TypeError("Expected function as last argument, not " + l);
    a(null, ...i);
    function a(u, ...s) {
      const f = e[++o];
      let c = -1;
      if (u) {
        l(u);
        return;
      }
      for (; ++c < i.length; )
        (s[c] === null || s[c] === void 0) && (s[c] = i[c]);
      i = s, f ? ru(f, a)(...s) : l(null, ...s);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function ru(e, t) {
  let n;
  return r;
  function r(...l) {
    const a = e.length > l.length;
    let u;
    a && l.push(i);
    try {
      u = e.apply(this, l);
    } catch (s) {
      const f = (
        /** @type {Error} */
        s
      );
      if (a && n)
        throw f;
      return i(f);
    }
    a || (u && u.then && typeof u.then == "function" ? u.then(o, i) : u instanceof Error ? i(u) : o(u));
  }
  function i(l, ...a) {
    n || (n = !0, t(l, ...a));
  }
  function o(l) {
    i(null, l);
  }
}
const fe = { basename: iu, dirname: lu, extname: ou, join: au, sep: "/" };
function iu(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ve(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let l = -1, a = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      l < 0 && (o = !0, l = i + 1), a > -1 && (e.codePointAt(i) === t.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = l));
  return n === r ? r = l : r < 0 && (r = e.length), e.slice(n, r);
}
function lu(e) {
  if (Ve(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function ou(e) {
  Ve(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, l;
  for (; t--; ) {
    const a = e.codePointAt(t);
    if (a === 47) {
      if (l) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (l = !0, n = t + 1), a === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function au(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ve(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : uu(n);
}
function uu(e) {
  Ve(e);
  const t = e.codePointAt(0) === 47;
  let n = su(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function su(e, t) {
  let n = "", r = 0, i = -1, o = 0, l = -1, a, u;
  for (; ++l <= e.length; ) {
    if (l < e.length)
      a = e.codePointAt(l);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === l - 1 || o === 1)) if (i !== l - 1 && o === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), i = l, o = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = l, o = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, l) : n = e.slice(i + 1, l), r = l - i - 1;
      i = l, o = 0;
    } else a === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Ve(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const cu = { cwd: fu };
function fu() {
  return "/";
}
function On(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function hu(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!On(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return pu(e);
}
function pu(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const dn = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class vr {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? On(t) ? n = { path: t } : typeof t == "string" || mu(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : cu.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < dn.length; ) {
      const o = dn[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      dn.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? fe.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    yn(t, "basename"), xn(t, "basename"), this.path = fe.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? fe.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Mt(this.basename, "dirname"), this.path = fe.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? fe.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (xn(t, "extname"), Mt(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = fe.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    On(t) && (t = hu(t)), yn(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? fe.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    yn(t, "stem"), xn(t, "stem"), this.path = fe.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new K(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function xn(e, t) {
  if (e && e.includes(fe.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + fe.sep + "`"
    );
}
function yn(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Mt(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function mu(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const gu = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], o = function() {
      return i.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, r), o;
  }
), du = {}.hasOwnProperty;
class Gn extends gu {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = tu();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Gn()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(gn(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (wn("data", this.frozen), this.namespace[t] = n, this) : du.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (wn("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = Xe(t), r = this.parser || this.Parser;
    return kn("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), kn("process", this.parser || this.Parser), bn("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(o, l) {
      const a = Xe(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(u, a, function(f, c, p) {
        if (f || !c || !p)
          return s(f);
        const h = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          c
        ), d = r.stringify(h, p);
        ku(d) ? p.value = d : p.result = d, s(
          f,
          /** @type {VFileWithOutput<CompileResult>} */
          p
        );
      });
      function s(f, c) {
        f || !c ? l(f) : o ? o(c) : n(void 0, c);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), kn("processSync", this.parser || this.Parser), bn("processSync", this.compiler || this.Compiler), this.process(t, i), _t("processSync", "process", n), r;
    function i(o, l) {
      n = !0, Dt(o), r = l;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    Rt(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? o(void 0, r) : new Promise(o);
    function o(l, a) {
      const u = Xe(n);
      i.run(t, u, s);
      function s(f, c, p) {
        const h = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          c || t
        );
        f ? a(f) : l ? l(h) : r(void 0, h, p);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, o), _t("runSync", "run", r), i;
    function o(l, a) {
      Dt(l), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = Xe(n), i = this.compiler || this.Compiler;
    return bn("stringify", i), Rt(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (wn("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? a(t) : l(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(s) {
      if (typeof s == "function")
        u(s, []);
      else if (typeof s == "object")
        if (Array.isArray(s)) {
          const [f, ...c] = (
            /** @type {PluginTuple<Array<unknown>>} */
            s
          );
          u(f, c);
        } else
          l(s);
      else
        throw new TypeError("Expected usable value, not `" + s + "`");
    }
    function l(s) {
      if (!("plugins" in s) && !("settings" in s))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(s.plugins), s.settings && (i.settings = gn(!0, i.settings, s.settings));
    }
    function a(s) {
      let f = -1;
      if (s != null) if (Array.isArray(s))
        for (; ++f < s.length; ) {
          const c = s[f];
          o(c);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + s + "`");
    }
    function u(s, f) {
      let c = -1, p = -1;
      for (; ++c < r.length; )
        if (r[c][0] === s) {
          p = c;
          break;
        }
      if (p === -1)
        r.push([s, ...f]);
      else if (f.length > 0) {
        let [h, ...d] = f;
        const x = r[p][1];
        Dn(x) && Dn(h) && (h = gn(!0, x, h)), r[p] = [s, h, ...d];
      }
    }
  }
}
const xu = new Gn().freeze();
function kn(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function bn(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function wn(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Rt(e) {
  if (!Dn(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function _t(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Xe(e) {
  return yu(e) ? e : new vr(e);
}
function yu(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function ku(e) {
  return typeof e == "string" || bu(e);
}
function bu(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const wu = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Nt = [], Bt = { allowDangerousHtml: !0 }, Su = /^(https?|ircs?|mailto|xmpp)$/i, Cu = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function Eu(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, o = e.components, l = e.disallowedElements, a = e.rehypePlugins || Nt, u = e.remarkPlugins || Nt, s = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Bt } : Bt, f = e.skipHtml, c = e.unwrapDisallowed, p = e.urlTransform || Iu, h = xu().use(la).use(u).use(Za, s).use(a), d = new vr();
  typeof r == "string" && (d.value = r);
  for (const y of Cu)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + wu + y.id, void 0);
  const x = h.parse(d);
  let C = h.runSync(x, d);
  return i && (C = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      C.type === "root" ? C.children : [C]
    )
  }), Xn(C, b), ji(C, {
    Fragment: si,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: J,
    jsxs: ci,
    passKeys: !0,
    passNode: !0
  });
  function b(y, E, L) {
    if (y.type === "raw" && L && typeof E == "number")
      return f ? L.children.splice(E, 1) : L.children[E] = { type: "text", value: y.value }, E;
    if (y.type === "element") {
      let D;
      for (D in fn)
        if (Object.hasOwn(fn, D) && Object.hasOwn(y.properties, D)) {
          const S = y.properties[D], O = fn[D];
          (O === null || O.includes(y.tagName)) && (y.properties[D] = p(String(S || ""), D, y));
        }
    }
    if (y.type === "element") {
      let D = t ? !t.includes(y.tagName) : l ? l.includes(y.tagName) : !1;
      if (!D && n && typeof E == "number" && (D = !n(y, E, L)), D && L && typeof E == "number")
        return c && y.children ? L.children.splice(E, 1, ...y.children) : L.children.splice(E, 1), E;
    }
  }
}
function Iu(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    Su.test(e.slice(0, t)) ? e : ""
  );
}
function jt(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function Tu(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Au(e, t, n) {
  const i = an((n || {}).ignore || []), o = Fu(t);
  let l = -1;
  for (; ++l < o.length; )
    Pr(e, "text", a);
  function a(s, f) {
    let c = -1, p;
    for (; ++c < f.length; ) {
      const h = f[c], d = p ? p.children : void 0;
      if (i(
        h,
        d ? d.indexOf(h) : void 0,
        p
      ))
        return;
      p = h;
    }
    if (p)
      return u(s, f);
  }
  function u(s, f) {
    const c = f[f.length - 1], p = o[l][0], h = o[l][1];
    let d = 0;
    const C = c.children.indexOf(s);
    let b = !1, y = [];
    p.lastIndex = 0;
    let E = p.exec(s.value);
    for (; E; ) {
      const L = E.index, D = {
        index: E.index,
        input: E.input,
        stack: [...f, s]
      };
      let S = h(...E, D);
      if (typeof S == "string" && (S = S.length > 0 ? { type: "text", value: S } : void 0), S === !1 ? p.lastIndex = L + 1 : (d !== L && y.push({
        type: "text",
        value: s.value.slice(d, L)
      }), Array.isArray(S) ? y.push(...S) : S && y.push(S), d = L + E[0].length, b = !0), !p.global)
        break;
      E = p.exec(s.value);
    }
    return b ? (d < s.value.length && y.push({ type: "text", value: s.value.slice(d) }), c.children.splice(C, 1, ...y)) : y = [s], C + y.length;
  }
}
function Fu(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    t.push([Pu(i[0]), vu(i[1])]);
  }
  return t;
}
function Pu(e) {
  return typeof e == "string" ? new RegExp(Tu(e), "g") : e;
}
function vu(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
const Sn = "phrasing", Cn = ["autolink", "link", "image", "label"];
function zu() {
  return {
    transforms: [Nu],
    enter: {
      literalAutolink: Du,
      literalAutolinkEmail: En,
      literalAutolinkHttp: En,
      literalAutolinkWww: En
    },
    exit: {
      literalAutolink: _u,
      literalAutolinkEmail: Ru,
      literalAutolinkHttp: Ou,
      literalAutolinkWww: Mu
    }
  };
}
function Lu() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: Sn,
        notInConstruct: Cn
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: Sn,
        notInConstruct: Cn
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: Sn,
        notInConstruct: Cn
      }
    ]
  };
}
function Du(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function En(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function Ou(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Mu(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function Ru(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function _u(e) {
  this.exit(e);
}
function Nu(e) {
  Au(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Bu],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), ju]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function Bu(e, t, n, r, i) {
  let o = "";
  if (!zr(i) || (/^w/i.test(t) && (n = t + n, t = "", o = "http://"), !$u(n)))
    return !1;
  const l = qu(n + r);
  if (!l[0]) return !1;
  const a = {
    type: "link",
    title: null,
    url: o + t + l[0],
    children: [{ type: "text", value: t + l[0] }]
  };
  return l[1] ? [a, { type: "text", value: l[1] }] : a;
}
function ju(e, t, n, r) {
  return (
    // Not an expected previous character.
    !zr(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function $u(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function qu(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = jt(e, "(");
  let o = jt(e, ")");
  for (; r !== -1 && i > o; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), o++;
  return [e, n];
}
function zr(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Ee(n) || rn(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
Lr.peek = Zu;
function Hu() {
  return {
    enter: {
      gfmFootnoteDefinition: Vu,
      gfmFootnoteDefinitionLabelString: Wu,
      gfmFootnoteCall: Xu,
      gfmFootnoteCallString: Gu
    },
    exit: {
      gfmFootnoteDefinition: Yu,
      gfmFootnoteDefinitionLabelString: Qu,
      gfmFootnoteCall: Ju,
      gfmFootnoteCallString: Ku
    }
  };
}
function Uu() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: es, footnoteReference: Lr }
  };
}
function Vu(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function Wu() {
  this.buffer();
}
function Qu(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = t, n.identifier = ce(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function Yu(e) {
  this.exit(e);
}
function Xu(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function Gu() {
  this.buffer();
}
function Ku(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = t, n.identifier = ce(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function Ju(e) {
  this.exit(e);
}
function Lr(e, t, n, r) {
  const i = n.createTracker(r);
  let o = i.move("[^");
  const l = n.enter("footnoteReference"), a = n.enter("reference");
  return o += i.move(
    n.safe(n.associationId(e), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), a(), l(), o += i.move("]"), o;
}
function Zu() {
  return "[";
}
function es(e, t, n, r) {
  const i = n.createTracker(r);
  let o = i.move("[^");
  const l = n.enter("footnoteDefinition"), a = n.enter("label");
  return o += i.move(
    n.safe(n.associationId(e), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), a(), o += i.move(
    "]:" + (e.children && e.children.length > 0 ? " " : "")
  ), i.shift(4), o += i.move(
    n.indentLines(n.containerFlow(e, i.current()), ns)
  ), l(), o;
}
function ns(e, t, n) {
  return t === 0 ? e : (n ? "" : "    ") + e;
}
const ts = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
Dr.peek = as;
function rs() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: ls },
    exit: { strikethrough: os }
  };
}
function is() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: ts
      }
    ],
    handlers: { delete: Dr }
  };
}
function ls(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function os(e) {
  this.exit(e);
}
function Dr(e, t, n, r) {
  const i = n.createTracker(r), o = n.enter("strikethrough");
  let l = i.move("~~");
  return l += n.containerPhrasing(e, {
    ...i.current(),
    before: l,
    after: "~"
  }), l += i.move("~~"), o(), l;
}
function as() {
  return "~";
}
function us(e, t = {}) {
  const n = (t.align || []).concat(), r = t.stringLength || cs, i = [], o = [], l = [], a = [];
  let u = 0, s = -1;
  for (; ++s < e.length; ) {
    const d = [], x = [];
    let C = -1;
    for (e[s].length > u && (u = e[s].length); ++C < e[s].length; ) {
      const b = ss(e[s][C]);
      if (t.alignDelimiters !== !1) {
        const y = r(b);
        x[C] = y, (a[C] === void 0 || y > a[C]) && (a[C] = y);
      }
      d.push(b);
    }
    o[s] = d, l[s] = x;
  }
  let f = -1;
  if (typeof n == "object" && "length" in n)
    for (; ++f < u; )
      i[f] = $t(n[f]);
  else {
    const d = $t(n);
    for (; ++f < u; )
      i[f] = d;
  }
  f = -1;
  const c = [], p = [];
  for (; ++f < u; ) {
    const d = i[f];
    let x = "", C = "";
    d === 99 ? (x = ":", C = ":") : d === 108 ? x = ":" : d === 114 && (C = ":");
    let b = t.alignDelimiters === !1 ? 1 : Math.max(
      1,
      a[f] - x.length - C.length
    );
    const y = x + "-".repeat(b) + C;
    t.alignDelimiters !== !1 && (b = x.length + b + C.length, b > a[f] && (a[f] = b), p[f] = b), c[f] = y;
  }
  o.splice(1, 0, c), l.splice(1, 0, p), s = -1;
  const h = [];
  for (; ++s < o.length; ) {
    const d = o[s], x = l[s];
    f = -1;
    const C = [];
    for (; ++f < u; ) {
      const b = d[f] || "";
      let y = "", E = "";
      if (t.alignDelimiters !== !1) {
        const L = a[f] - (x[f] || 0), D = i[f];
        D === 114 ? y = " ".repeat(L) : D === 99 ? L % 2 ? (y = " ".repeat(L / 2 + 0.5), E = " ".repeat(L / 2 - 0.5)) : (y = " ".repeat(L / 2), E = y) : E = " ".repeat(L);
      }
      t.delimiterStart !== !1 && !f && C.push("|"), t.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(t.alignDelimiters === !1 && b === "") && (t.delimiterStart !== !1 || f) && C.push(" "), t.alignDelimiters !== !1 && C.push(y), C.push(b), t.alignDelimiters !== !1 && C.push(E), t.padding !== !1 && C.push(" "), (t.delimiterEnd !== !1 || f !== u - 1) && C.push("|");
    }
    h.push(
      t.delimiterEnd === !1 ? C.join("").replace(/ +$/, "") : C.join("")
    );
  }
  return h.join(`
`);
}
function ss(e) {
  return e == null ? "" : String(e);
}
function cs(e) {
  return e.length;
}
function $t(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function fs(e, t, n, r) {
  const i = n.enter("blockquote"), o = n.createTracker(r);
  o.move("> "), o.shift(2);
  const l = n.indentLines(
    n.containerFlow(e, o.current()),
    hs
  );
  return i(), l;
}
function hs(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function ps(e, t) {
  return qt(e, t.inConstruct, !0) && !qt(e, t.notInConstruct, !1);
}
function qt(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Ht(e, t, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && ps(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function Or(e, t) {
  const n = String(e);
  let r = n.indexOf(t), i = r, o = 0, l = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++o > l && (l = o) : o = 1, i = r + t.length, r = n.indexOf(t, i);
  return l;
}
function ms(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function gs(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function ds(e, t, n, r) {
  const i = gs(n), o = e.value || "", l = i === "`" ? "GraveAccent" : "Tilde";
  if (ms(e, n)) {
    const c = n.enter("codeIndented"), p = n.indentLines(o, xs);
    return c(), p;
  }
  const a = n.createTracker(r), u = i.repeat(Math.max(Or(o, i) + 1, 3)), s = n.enter("codeFenced");
  let f = a.move(u);
  if (e.lang) {
    const c = n.enter(`codeFencedLang${l}`);
    f += a.move(
      n.safe(e.lang, {
        before: f,
        after: " ",
        encode: ["`"],
        ...a.current()
      })
    ), c();
  }
  if (e.lang && e.meta) {
    const c = n.enter(`codeFencedMeta${l}`);
    f += a.move(" "), f += a.move(
      n.safe(e.meta, {
        before: f,
        after: `
`,
        encode: ["`"],
        ...a.current()
      })
    ), c();
  }
  return f += a.move(`
`), o && (f += a.move(o + `
`)), f += a.move(u), s(), f;
}
function xs(e, t, n) {
  return (n ? "" : "    ") + e;
}
function Kn(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function ys(e, t, n, r) {
  const i = Kn(n), o = i === '"' ? "Quote" : "Apostrophe", l = n.enter("definition");
  let a = n.enter("label");
  const u = n.createTracker(r);
  let s = u.move("[");
  return s += u.move(
    n.safe(n.associationId(e), {
      before: s,
      after: "]",
      ...u.current()
    })
  ), s += u.move("]: "), a(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (a = n.enter("destinationLiteral"), s += u.move("<"), s += u.move(
    n.safe(e.url, { before: s, after: ">", ...u.current() })
  ), s += u.move(">")) : (a = n.enter("destinationRaw"), s += u.move(
    n.safe(e.url, {
      before: s,
      after: e.title ? " " : `
`,
      ...u.current()
    })
  )), a(), e.title && (a = n.enter(`title${o}`), s += u.move(" " + i), s += u.move(
    n.safe(e.title, {
      before: s,
      after: i,
      ...u.current()
    })
  ), s += u.move(i), a()), l(), s;
}
function ks(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
Mr.peek = bs;
function Mr(e, t, n, r) {
  const i = ks(n), o = n.enter("emphasis"), l = n.createTracker(r);
  let a = l.move(i);
  return a += l.move(
    n.containerPhrasing(e, {
      before: a,
      after: i,
      ...l.current()
    })
  ), a += l.move(i), o(), a;
}
function bs(e, t, n) {
  return n.options.emphasis || "*";
}
function ws(e, t) {
  let n = !1;
  return Xn(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, zn;
  }), !!((!e.depth || e.depth < 3) && qn(e) && (t.options.setext || n));
}
function Ss(e, t, n, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), o = n.createTracker(r);
  if (ws(e, n)) {
    const f = n.enter("headingSetext"), c = n.enter("phrasing"), p = n.containerPhrasing(e, {
      ...o.current(),
      before: `
`,
      after: `
`
    });
    return c(), f(), p + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      p.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(p.lastIndexOf("\r"), p.lastIndexOf(`
`)) + 1)
    );
  }
  const l = "#".repeat(i), a = n.enter("headingAtx"), u = n.enter("phrasing");
  o.move(l + " ");
  let s = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...o.current()
  });
  return /^[\t ]/.test(s) && (s = "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";" + s.slice(1)), s = s ? l + " " + s : l, n.options.closeAtx && (s += " " + l), u(), a(), s;
}
Rr.peek = Cs;
function Rr(e) {
  return e.value || "";
}
function Cs() {
  return "<";
}
_r.peek = Es;
function _r(e, t, n, r) {
  const i = Kn(n), o = i === '"' ? "Quote" : "Apostrophe", l = n.enter("image");
  let a = n.enter("label");
  const u = n.createTracker(r);
  let s = u.move("![");
  return s += u.move(
    n.safe(e.alt, { before: s, after: "]", ...u.current() })
  ), s += u.move("]("), a(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (a = n.enter("destinationLiteral"), s += u.move("<"), s += u.move(
    n.safe(e.url, { before: s, after: ">", ...u.current() })
  ), s += u.move(">")) : (a = n.enter("destinationRaw"), s += u.move(
    n.safe(e.url, {
      before: s,
      after: e.title ? " " : ")",
      ...u.current()
    })
  )), a(), e.title && (a = n.enter(`title${o}`), s += u.move(" " + i), s += u.move(
    n.safe(e.title, {
      before: s,
      after: i,
      ...u.current()
    })
  ), s += u.move(i), a()), s += u.move(")"), l(), s;
}
function Es() {
  return "!";
}
Nr.peek = Is;
function Nr(e, t, n, r) {
  const i = e.referenceType, o = n.enter("imageReference");
  let l = n.enter("label");
  const a = n.createTracker(r);
  let u = a.move("![");
  const s = n.safe(e.alt, {
    before: u,
    after: "]",
    ...a.current()
  });
  u += a.move(s + "]["), l();
  const f = n.stack;
  n.stack = [], l = n.enter("reference");
  const c = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...a.current()
  });
  return l(), n.stack = f, o(), i === "full" || !s || s !== c ? u += a.move(c + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += a.move("]"), u;
}
function Is() {
  return "!";
}
Br.peek = Ts;
function Br(e, t, n) {
  let r = e.value || "", i = "`", o = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++o < n.unsafe.length; ) {
    const l = n.unsafe[o], a = n.compilePattern(l);
    let u;
    if (l.atBreak)
      for (; u = a.exec(r); ) {
        let s = u.index;
        r.charCodeAt(s) === 10 && r.charCodeAt(s - 1) === 13 && s--, r = r.slice(0, s) + " " + r.slice(u.index + 1);
      }
  }
  return i + r + i;
}
function Ts() {
  return "`";
}
function jr(e, t) {
  const n = qn(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
$r.peek = As;
function $r(e, t, n, r) {
  const i = Kn(n), o = i === '"' ? "Quote" : "Apostrophe", l = n.createTracker(r);
  let a, u;
  if (jr(e, n)) {
    const f = n.stack;
    n.stack = [], a = n.enter("autolink");
    let c = l.move("<");
    return c += l.move(
      n.containerPhrasing(e, {
        before: c,
        after: ">",
        ...l.current()
      })
    ), c += l.move(">"), a(), n.stack = f, c;
  }
  a = n.enter("link"), u = n.enter("label");
  let s = l.move("[");
  return s += l.move(
    n.containerPhrasing(e, {
      before: s,
      after: "](",
      ...l.current()
    })
  ), s += l.move("]("), u(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (u = n.enter("destinationLiteral"), s += l.move("<"), s += l.move(
    n.safe(e.url, { before: s, after: ">", ...l.current() })
  ), s += l.move(">")) : (u = n.enter("destinationRaw"), s += l.move(
    n.safe(e.url, {
      before: s,
      after: e.title ? " " : ")",
      ...l.current()
    })
  )), u(), e.title && (u = n.enter(`title${o}`), s += l.move(" " + i), s += l.move(
    n.safe(e.title, {
      before: s,
      after: i,
      ...l.current()
    })
  ), s += l.move(i), u()), s += l.move(")"), a(), s;
}
function As(e, t, n) {
  return jr(e, n) ? "<" : "[";
}
qr.peek = Fs;
function qr(e, t, n, r) {
  const i = e.referenceType, o = n.enter("linkReference");
  let l = n.enter("label");
  const a = n.createTracker(r);
  let u = a.move("[");
  const s = n.containerPhrasing(e, {
    before: u,
    after: "]",
    ...a.current()
  });
  u += a.move(s + "]["), l();
  const f = n.stack;
  n.stack = [], l = n.enter("reference");
  const c = n.safe(n.associationId(e), {
    before: u,
    after: "]",
    ...a.current()
  });
  return l(), n.stack = f, o(), i === "full" || !s || s !== c ? u += a.move(c + "]") : i === "shortcut" ? u = u.slice(0, -1) : u += a.move("]"), u;
}
function Fs() {
  return "[";
}
function Jn(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function Ps(e) {
  const t = Jn(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function vs(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function Hr(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function zs(e, t, n, r) {
  const i = n.enter("list"), o = n.bulletCurrent;
  let l = e.ordered ? vs(n) : Jn(n);
  const a = e.ordered ? l === "." ? ")" : "." : Ps(n);
  let u = t && n.bulletLastUsed ? l === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const f = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (l === "*" || l === "-") && // Empty first list item:
      f && (!f.children || !f.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (u = !0), Hr(n) === l && f
    ) {
      let c = -1;
      for (; ++c < e.children.length; ) {
        const p = e.children[c];
        if (p && p.type === "listItem" && p.children && p.children[0] && p.children[0].type === "thematicBreak") {
          u = !0;
          break;
        }
      }
    }
  }
  u && (l = a), n.bulletCurrent = l;
  const s = n.containerFlow(e, r);
  return n.bulletLastUsed = l, n.bulletCurrent = o, i(), s;
}
function Ls(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function Ds(e, t, n, r) {
  const i = Ls(n);
  let o = n.bulletCurrent || Jn(n);
  t && t.type === "list" && t.ordered && (o = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + o);
  let l = o.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (l = Math.ceil(l / 4) * 4);
  const a = n.createTracker(r);
  a.move(o + " ".repeat(l - o.length)), a.shift(l);
  const u = n.enter("listItem"), s = n.indentLines(
    n.containerFlow(e, a.current()),
    f
  );
  return u(), s;
  function f(c, p, h) {
    return p ? (h ? "" : " ".repeat(l)) + c : (h ? o : o + " ".repeat(l - o.length)) + c;
  }
}
function Os(e, t, n, r) {
  const i = n.enter("paragraph"), o = n.enter("phrasing"), l = n.containerPhrasing(e, r);
  return o(), i(), l;
}
const Ms = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  an([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function Rs(e, t, n, r) {
  return (e.children.some(function(l) {
    return Ms(l);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function _s(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
Ur.peek = Ns;
function Ur(e, t, n, r) {
  const i = _s(n), o = n.enter("strong"), l = n.createTracker(r);
  let a = l.move(i + i);
  return a += l.move(
    n.containerPhrasing(e, {
      before: a,
      after: i,
      ...l.current()
    })
  ), a += l.move(i + i), o(), a;
}
function Ns(e, t, n) {
  return n.options.strong || "*";
}
function Bs(e, t, n, r) {
  return n.safe(e.value, r);
}
function js(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function $s(e, t, n) {
  const r = (Hr(n) + (n.options.ruleSpaces ? " " : "")).repeat(js(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const Vr = {
  blockquote: fs,
  break: Ht,
  code: ds,
  definition: ys,
  emphasis: Mr,
  hardBreak: Ht,
  heading: Ss,
  html: Rr,
  image: _r,
  imageReference: Nr,
  inlineCode: Br,
  link: $r,
  linkReference: qr,
  list: zs,
  listItem: Ds,
  paragraph: Os,
  root: Rs,
  strong: Ur,
  text: Bs,
  thematicBreak: $s
};
function qs() {
  return {
    enter: {
      table: Hs,
      tableData: Ut,
      tableHeader: Ut,
      tableRow: Vs
    },
    exit: {
      codeText: Ws,
      table: Us,
      tableData: In,
      tableHeader: In,
      tableRow: In
    }
  };
}
function Hs(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function Us(e) {
  this.exit(e), this.data.inTable = void 0;
}
function Vs(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function In(e) {
  this.exit(e);
}
function Ut(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function Ws(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, Qs));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function Qs(e, t) {
  return t === "|" ? t : e;
}
function Ys(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, o = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: p,
      table: l,
      tableCell: u,
      tableRow: a
    }
  };
  function l(h, d, x, C) {
    return s(f(h, x, C), h.align);
  }
  function a(h, d, x, C) {
    const b = c(h, x, C), y = s([b]);
    return y.slice(0, y.indexOf(`
`));
  }
  function u(h, d, x, C) {
    const b = x.enter("tableCell"), y = x.enter("phrasing"), E = x.containerPhrasing(h, {
      ...C,
      before: o,
      after: o
    });
    return y(), b(), E;
  }
  function s(h, d) {
    return us(h, {
      align: d,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function f(h, d, x) {
    const C = h.children;
    let b = -1;
    const y = [], E = d.enter("table");
    for (; ++b < C.length; )
      y[b] = c(C[b], d, x);
    return E(), y;
  }
  function c(h, d, x) {
    const C = h.children;
    let b = -1;
    const y = [], E = d.enter("tableRow");
    for (; ++b < C.length; )
      y[b] = u(C[b], h, d, x);
    return E(), y;
  }
  function p(h, d, x) {
    let C = Vr.inlineCode(h, d, x);
    return x.stack.includes("tableCell") && (C = C.replace(/\|/g, "\\$&")), C;
  }
}
function Xs() {
  return {
    exit: {
      taskListCheckValueChecked: Vt,
      taskListCheckValueUnchecked: Vt,
      paragraph: Ks
    }
  };
}
function Gs() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: Js }
  };
}
function Vt(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function Ks(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let o = -1, l;
      for (; ++o < i.length; ) {
        const a = i[o];
        if (a.type === "paragraph") {
          l = a;
          break;
        }
      }
      l === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function Js(e, t, n, r) {
  const i = e.children[0], o = typeof e.checked == "boolean" && i && i.type === "paragraph", l = "[" + (e.checked ? "x" : " ") + "] ", a = n.createTracker(r);
  o && a.move(l);
  let u = Vr.listItem(e, t, n, {
    ...r,
    ...a.current()
  });
  return o && (u = u.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, s)), u;
  function s(f) {
    return f + l;
  }
}
function Zs() {
  return [
    zu(),
    Hu(),
    rs(),
    qs(),
    Xs()
  ];
}
function ec(e) {
  return {
    extensions: [
      Lu(),
      Uu(),
      is(),
      Ys(e),
      Gs()
    ]
  };
}
const nc = {
  tokenize: ac,
  partial: !0
}, Wr = {
  tokenize: uc,
  partial: !0
}, Qr = {
  tokenize: sc,
  partial: !0
}, Yr = {
  tokenize: cc,
  partial: !0
}, tc = {
  tokenize: fc,
  partial: !0
}, Xr = {
  name: "wwwAutolink",
  tokenize: lc,
  previous: Kr
}, Gr = {
  name: "protocolAutolink",
  tokenize: oc,
  previous: Jr
}, xe = {
  name: "emailAutolink",
  tokenize: ic,
  previous: Zr
}, he = {};
function rc() {
  return {
    text: he
  };
}
let Ce = 48;
for (; Ce < 123; )
  he[Ce] = xe, Ce++, Ce === 58 ? Ce = 65 : Ce === 91 && (Ce = 97);
he[43] = xe;
he[45] = xe;
he[46] = xe;
he[95] = xe;
he[72] = [xe, Gr];
he[104] = [xe, Gr];
he[87] = [xe, Xr];
he[119] = [xe, Xr];
function ic(e, t, n) {
  const r = this;
  let i, o;
  return l;
  function l(c) {
    return !Mn(c) || !Zr.call(r, r.previous) || Zn(r.events) ? n(c) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), a(c));
  }
  function a(c) {
    return Mn(c) ? (e.consume(c), a) : c === 64 ? (e.consume(c), u) : n(c);
  }
  function u(c) {
    return c === 46 ? e.check(tc, f, s)(c) : c === 45 || c === 95 || G(c) ? (o = !0, e.consume(c), u) : f(c);
  }
  function s(c) {
    return e.consume(c), i = !0, u;
  }
  function f(c) {
    return o && i && Z(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(c)) : n(c);
  }
}
function lc(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return l !== 87 && l !== 119 || !Kr.call(r, r.previous) || Zn(r.events) ? n(l) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(nc, e.attempt(Wr, e.attempt(Qr, o), n), n)(l));
  }
  function o(l) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(l);
  }
}
function oc(e, t, n) {
  const r = this;
  let i = "", o = !1;
  return l;
  function l(c) {
    return (c === 72 || c === 104) && Jr.call(r, r.previous) && !Zn(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(c), e.consume(c), a) : n(c);
  }
  function a(c) {
    if (Z(c) && i.length < 5)
      return i += String.fromCodePoint(c), e.consume(c), a;
    if (c === 58) {
      const p = i.toLowerCase();
      if (p === "http" || p === "https")
        return e.consume(c), u;
    }
    return n(c);
  }
  function u(c) {
    return c === 47 ? (e.consume(c), o ? s : (o = !0, u)) : n(c);
  }
  function s(c) {
    return c === null || Je(c) || U(c) || Ee(c) || rn(c) ? n(c) : e.attempt(Wr, e.attempt(Qr, f), n)(c);
  }
  function f(c) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(c);
  }
}
function ac(e, t, n) {
  let r = 0;
  return i;
  function i(l) {
    return (l === 87 || l === 119) && r < 3 ? (r++, e.consume(l), i) : l === 46 && r === 3 ? (e.consume(l), o) : n(l);
  }
  function o(l) {
    return l === null ? n(l) : t(l);
  }
}
function uc(e, t, n) {
  let r, i, o;
  return l;
  function l(s) {
    return s === 46 || s === 95 ? e.check(Yr, u, a)(s) : s === null || U(s) || Ee(s) || s !== 45 && rn(s) ? u(s) : (o = !0, e.consume(s), l);
  }
  function a(s) {
    return s === 95 ? r = !0 : (i = r, r = void 0), e.consume(s), l;
  }
  function u(s) {
    return i || r || !o ? n(s) : t(s);
  }
}
function sc(e, t) {
  let n = 0, r = 0;
  return i;
  function i(l) {
    return l === 40 ? (n++, e.consume(l), i) : l === 41 && r < n ? o(l) : l === 33 || l === 34 || l === 38 || l === 39 || l === 41 || l === 42 || l === 44 || l === 46 || l === 58 || l === 59 || l === 60 || l === 63 || l === 93 || l === 95 || l === 126 ? e.check(Yr, t, o)(l) : l === null || U(l) || Ee(l) ? t(l) : (e.consume(l), i);
  }
  function o(l) {
    return l === 41 && r++, e.consume(l), i;
  }
}
function cc(e, t, n) {
  return r;
  function r(a) {
    return a === 33 || a === 34 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 63 || a === 95 || a === 126 ? (e.consume(a), r) : a === 38 ? (e.consume(a), o) : a === 93 ? (e.consume(a), i) : (
      // `<` is an end.
      a === 60 || // So is whitespace.
      a === null || U(a) || Ee(a) ? t(a) : n(a)
    );
  }
  function i(a) {
    return a === null || a === 40 || a === 91 || U(a) || Ee(a) ? t(a) : r(a);
  }
  function o(a) {
    return Z(a) ? l(a) : n(a);
  }
  function l(a) {
    return a === 59 ? (e.consume(a), r) : Z(a) ? (e.consume(a), l) : n(a);
  }
}
function fc(e, t, n) {
  return r;
  function r(o) {
    return e.consume(o), i;
  }
  function i(o) {
    return G(o) ? n(o) : t(o);
  }
}
function Kr(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || U(e);
}
function Jr(e) {
  return !Z(e);
}
function Zr(e) {
  return !(e === 47 || Mn(e));
}
function Mn(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || G(e);
}
function Zn(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const hc = {
  tokenize: bc,
  partial: !0
};
function pc() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: xc,
        continuation: {
          tokenize: yc
        },
        exit: kc
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: dc
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: mc,
        resolveTo: gc
      }
    }
  };
}
function mc(e, t, n) {
  const r = this;
  let i = r.events.length;
  const o = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let l;
  for (; i--; ) {
    const u = r.events[i][1];
    if (u.type === "labelImage") {
      l = u;
      break;
    }
    if (u.type === "gfmFootnoteCall" || u.type === "labelLink" || u.type === "label" || u.type === "image" || u.type === "link")
      break;
  }
  return a;
  function a(u) {
    if (!l || !l._balanced)
      return n(u);
    const s = ce(r.sliceSerialize({
      start: l.end,
      end: r.now()
    }));
    return s.codePointAt(0) !== 94 || !o.includes(s.slice(1)) ? n(u) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(u), e.exit("gfmFootnoteCallLabelMarker"), t(u));
  }
}
function gc(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const o = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, l = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, o.start),
    end: Object.assign({}, o.end)
  }, a = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", o, t],
    ["enter", l, t],
    ["exit", l, t],
    ["exit", o, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...a), e;
}
function dc(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o = 0, l;
  return a;
  function a(c) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), u;
  }
  function u(c) {
    return c !== 94 ? n(c) : (e.enter("gfmFootnoteCallMarker"), e.consume(c), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", s);
  }
  function s(c) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      c === 93 && !l || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      c === null || c === 91 || U(c)
    )
      return n(c);
    if (c === 93) {
      e.exit("chunkString");
      const p = e.exit("gfmFootnoteCallString");
      return i.includes(ce(r.sliceSerialize(p))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(c);
    }
    return U(c) || (l = !0), o++, e.consume(c), c === 92 ? f : s;
  }
  function f(c) {
    return c === 91 || c === 92 || c === 93 ? (e.consume(c), o++, s) : s(c);
  }
}
function xc(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o, l = 0, a;
  return u;
  function u(d) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(d), e.exit("gfmFootnoteDefinitionLabelMarker"), s;
  }
  function s(d) {
    return d === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(d), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", f) : n(d);
  }
  function f(d) {
    if (
      // Too long.
      l > 999 || // Closing brace with nothing.
      d === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      d === null || d === 91 || U(d)
    )
      return n(d);
    if (d === 93) {
      e.exit("chunkString");
      const x = e.exit("gfmFootnoteDefinitionLabelString");
      return o = ce(r.sliceSerialize(x)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(d), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), p;
    }
    return U(d) || (a = !0), l++, e.consume(d), d === 92 ? c : f;
  }
  function c(d) {
    return d === 91 || d === 92 || d === 93 ? (e.consume(d), l++, f) : f(d);
  }
  function p(d) {
    return d === 58 ? (e.enter("definitionMarker"), e.consume(d), e.exit("definitionMarker"), i.includes(o) || i.push(o), B(e, h, "gfmFootnoteDefinitionWhitespace")) : n(d);
  }
  function h(d) {
    return t(d);
  }
}
function yc(e, t, n) {
  return e.check(Ue, t, e.attempt(hc, t, n));
}
function kc(e) {
  e.exit("gfmFootnoteDefinition");
}
function bc(e, t, n) {
  const r = this;
  return B(e, i, "gfmFootnoteDefinitionIndent", 5);
  function i(o) {
    const l = r.events[r.events.length - 1];
    return l && l[1].type === "gfmFootnoteDefinitionIndent" && l[2].sliceSerialize(l[1], !0).length === 4 ? t(o) : n(o);
  }
}
function wc(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: o,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(l, a) {
    let u = -1;
    for (; ++u < l.length; )
      if (l[u][0] === "enter" && l[u][1].type === "strikethroughSequenceTemporary" && l[u][1]._close) {
        let s = u;
        for (; s--; )
          if (l[s][0] === "exit" && l[s][1].type === "strikethroughSequenceTemporary" && l[s][1]._open && // If the sizes are the same:
          l[u][1].end.offset - l[u][1].start.offset === l[s][1].end.offset - l[s][1].start.offset) {
            l[u][1].type = "strikethroughSequence", l[s][1].type = "strikethroughSequence";
            const f = {
              type: "strikethrough",
              start: Object.assign({}, l[s][1].start),
              end: Object.assign({}, l[u][1].end)
            }, c = {
              type: "strikethroughText",
              start: Object.assign({}, l[s][1].end),
              end: Object.assign({}, l[u][1].start)
            }, p = [["enter", f, a], ["enter", l[s][1], a], ["exit", l[s][1], a], ["enter", c, a]], h = a.parser.constructs.insideSpan.null;
            h && ie(p, p.length, 0, ln(h, l.slice(s + 1, u), a)), ie(p, p.length, 0, [["exit", c, a], ["enter", l[u][1], a], ["exit", l[u][1], a], ["exit", f, a]]), ie(l, s - 1, u - s + 3, p), u = s + p.length - 2;
            break;
          }
      }
    for (u = -1; ++u < l.length; )
      l[u][1].type === "strikethroughSequenceTemporary" && (l[u][1].type = "data");
    return l;
  }
  function o(l, a, u) {
    const s = this.previous, f = this.events;
    let c = 0;
    return p;
    function p(d) {
      return s === 126 && f[f.length - 1][1].type !== "characterEscape" ? u(d) : (l.enter("strikethroughSequenceTemporary"), h(d));
    }
    function h(d) {
      const x = Ze(s);
      if (d === 126)
        return c > 1 ? u(d) : (l.consume(d), c++, h);
      if (c < 2 && !n) return u(d);
      const C = l.exit("strikethroughSequenceTemporary"), b = Ze(d);
      return C._open = !b || b === 2 && !!x, C._close = !x || x === 2 && !!b, a(d);
    }
  }
}
class Sc {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    Cc(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(o, l) {
      return o[0] - l[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push([...t]), t.length = 0;
    let i = r.pop();
    for (; i; )
      t.push(...i), i = r.pop();
    this.map.length = 0;
  }
}
function Cc(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function Ec(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const o = r.length - 1;
          r[o] = r[o] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function Ic() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: Tc,
        resolveAll: Ac
      }
    }
  };
}
function Tc(e, t, n) {
  const r = this;
  let i = 0, o = 0, l;
  return a;
  function a(k) {
    let P = r.events.length - 1;
    for (; P > -1; ) {
      const A = r.events[P][1].type;
      if (A === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      A === "linePrefix") P--;
      else break;
    }
    const v = P > -1 ? r.events[P][1].type : null, z = v === "tableHead" || v === "tableRow" ? S : u;
    return z === S && r.parser.lazy[r.now().line] ? n(k) : z(k);
  }
  function u(k) {
    return e.enter("tableHead"), e.enter("tableRow"), s(k);
  }
  function s(k) {
    return k === 124 || (l = !0, o += 1), f(k);
  }
  function f(k) {
    return k === null ? n(k) : F(k) ? o > 1 ? (o = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), h) : n(k) : j(k) ? B(e, f, "whitespace")(k) : (o += 1, l && (l = !1, i += 1), k === 124 ? (e.enter("tableCellDivider"), e.consume(k), e.exit("tableCellDivider"), l = !0, f) : (e.enter("data"), c(k)));
  }
  function c(k) {
    return k === null || k === 124 || U(k) ? (e.exit("data"), f(k)) : (e.consume(k), k === 92 ? p : c);
  }
  function p(k) {
    return k === 92 || k === 124 ? (e.consume(k), c) : c(k);
  }
  function h(k) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(k) : (e.enter("tableDelimiterRow"), l = !1, j(k) ? B(e, d, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(k) : d(k));
  }
  function d(k) {
    return k === 45 || k === 58 ? C(k) : k === 124 ? (l = !0, e.enter("tableCellDivider"), e.consume(k), e.exit("tableCellDivider"), x) : D(k);
  }
  function x(k) {
    return j(k) ? B(e, C, "whitespace")(k) : C(k);
  }
  function C(k) {
    return k === 58 ? (o += 1, l = !0, e.enter("tableDelimiterMarker"), e.consume(k), e.exit("tableDelimiterMarker"), b) : k === 45 ? (o += 1, b(k)) : k === null || F(k) ? L(k) : D(k);
  }
  function b(k) {
    return k === 45 ? (e.enter("tableDelimiterFiller"), y(k)) : D(k);
  }
  function y(k) {
    return k === 45 ? (e.consume(k), y) : k === 58 ? (l = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(k), e.exit("tableDelimiterMarker"), E) : (e.exit("tableDelimiterFiller"), E(k));
  }
  function E(k) {
    return j(k) ? B(e, L, "whitespace")(k) : L(k);
  }
  function L(k) {
    return k === 124 ? d(k) : k === null || F(k) ? !l || i !== o ? D(k) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(k)) : D(k);
  }
  function D(k) {
    return n(k);
  }
  function S(k) {
    return e.enter("tableRow"), O(k);
  }
  function O(k) {
    return k === 124 ? (e.enter("tableCellDivider"), e.consume(k), e.exit("tableCellDivider"), O) : k === null || F(k) ? (e.exit("tableRow"), t(k)) : j(k) ? B(e, O, "whitespace")(k) : (e.enter("data"), q(k));
  }
  function q(k) {
    return k === null || k === 124 || U(k) ? (e.exit("data"), O(k)) : (e.consume(k), k === 92 ? R : q);
  }
  function R(k) {
    return k === 92 || k === 124 ? (e.consume(k), q) : q(k);
  }
}
function Ac(e, t) {
  let n = -1, r = !0, i = 0, o = [0, 0, 0, 0], l = [0, 0, 0, 0], a = !1, u = 0, s, f, c;
  const p = new Sc();
  for (; ++n < e.length; ) {
    const h = e[n], d = h[1];
    h[0] === "enter" ? d.type === "tableHead" ? (a = !1, u !== 0 && (Wt(p, t, u, s, f), f = void 0, u = 0), s = {
      type: "table",
      start: Object.assign({}, d.start),
      // Note: correct end is set later.
      end: Object.assign({}, d.end)
    }, p.add(n, 0, [["enter", s, t]])) : d.type === "tableRow" || d.type === "tableDelimiterRow" ? (r = !0, c = void 0, o = [0, 0, 0, 0], l = [0, n + 1, 0, 0], a && (a = !1, f = {
      type: "tableBody",
      start: Object.assign({}, d.start),
      // Note: correct end is set later.
      end: Object.assign({}, d.end)
    }, p.add(n, 0, [["enter", f, t]])), i = d.type === "tableDelimiterRow" ? 2 : f ? 3 : 1) : i && (d.type === "data" || d.type === "tableDelimiterMarker" || d.type === "tableDelimiterFiller") ? (r = !1, l[2] === 0 && (o[1] !== 0 && (l[0] = l[1], c = Ge(p, t, o, i, void 0, c), o = [0, 0, 0, 0]), l[2] = n)) : d.type === "tableCellDivider" && (r ? r = !1 : (o[1] !== 0 && (l[0] = l[1], c = Ge(p, t, o, i, void 0, c)), o = l, l = [o[1], n, 0, 0])) : d.type === "tableHead" ? (a = !0, u = n) : d.type === "tableRow" || d.type === "tableDelimiterRow" ? (u = n, o[1] !== 0 ? (l[0] = l[1], c = Ge(p, t, o, i, n, c)) : l[1] !== 0 && (c = Ge(p, t, l, i, n, c)), i = 0) : i && (d.type === "data" || d.type === "tableDelimiterMarker" || d.type === "tableDelimiterFiller") && (l[3] = n);
  }
  for (u !== 0 && Wt(p, t, u, s, f), p.consume(t.events), n = -1; ++n < t.events.length; ) {
    const h = t.events[n];
    h[0] === "enter" && h[1].type === "table" && (h[1]._align = Ec(t.events, n));
  }
  return e;
}
function Ge(e, t, n, r, i, o) {
  const l = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", a = "tableContent";
  n[0] !== 0 && (o.end = Object.assign({}, ze(t.events, n[0])), e.add(n[0], 0, [["exit", o, t]]));
  const u = ze(t.events, n[1]);
  if (o = {
    type: l,
    start: Object.assign({}, u),
    // Note: correct end is set later.
    end: Object.assign({}, u)
  }, e.add(n[1], 0, [["enter", o, t]]), n[2] !== 0) {
    const s = ze(t.events, n[2]), f = ze(t.events, n[3]), c = {
      type: a,
      start: Object.assign({}, s),
      end: Object.assign({}, f)
    };
    if (e.add(n[2], 0, [["enter", c, t]]), r !== 2) {
      const p = t.events[n[2]], h = t.events[n[3]];
      if (p[1].end = Object.assign({}, h[1].end), p[1].type = "chunkText", p[1].contentType = "text", n[3] > n[2] + 1) {
        const d = n[2] + 1, x = n[3] - n[2] - 1;
        e.add(d, x, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", c, t]]);
  }
  return i !== void 0 && (o.end = Object.assign({}, ze(t.events, i)), e.add(i, 0, [["exit", o, t]]), o = void 0), o;
}
function Wt(e, t, n, r, i) {
  const o = [], l = ze(t.events, n);
  i && (i.end = Object.assign({}, l), o.push(["exit", i, t])), r.end = Object.assign({}, l), o.push(["exit", r, t]), e.add(n + 1, 0, o);
}
function ze(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const Fc = {
  name: "tasklistCheck",
  tokenize: vc
};
function Pc() {
  return {
    text: {
      91: Fc
    }
  };
}
function vc(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(u) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), o)
    );
  }
  function o(u) {
    return U(u) ? (e.enter("taskListCheckValueUnchecked"), e.consume(u), e.exit("taskListCheckValueUnchecked"), l) : u === 88 || u === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(u), e.exit("taskListCheckValueChecked"), l) : n(u);
  }
  function l(u) {
    return u === 93 ? (e.enter("taskListCheckMarker"), e.consume(u), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), a) : n(u);
  }
  function a(u) {
    return F(u) ? t(u) : j(u) ? e.check({
      tokenize: zc
    }, t, n)(u) : n(u);
  }
}
function zc(e, t, n) {
  return B(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function Lc(e) {
  return cr([
    rc(),
    pc(),
    wc(e),
    Ic(),
    Pc()
  ]);
}
const Dc = {};
function Oc(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || Dc, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), o = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), l = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(Lc(n)), o.push(Zs()), l.push(ec(n));
}
function Mc() {
  return {
    enter: {
      mathFlow: e,
      mathFlowFenceMeta: t,
      mathText: o
    },
    exit: {
      mathFlow: i,
      mathFlowFence: r,
      mathFlowFenceMeta: n,
      mathFlowValue: a,
      mathText: l,
      mathTextData: a
    }
  };
  function e(u) {
    const s = {
      type: "element",
      tagName: "code",
      properties: { className: ["language-math", "math-display"] },
      children: []
    };
    this.enter(
      {
        type: "math",
        meta: null,
        value: "",
        data: { hName: "pre", hChildren: [s] }
      },
      u
    );
  }
  function t() {
    this.buffer();
  }
  function n() {
    const u = this.resume(), s = this.stack[this.stack.length - 1];
    s.type, s.meta = u;
  }
  function r() {
    this.data.mathFlowInside || (this.buffer(), this.data.mathFlowInside = !0);
  }
  function i(u) {
    const s = this.resume().replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), f = this.stack[this.stack.length - 1];
    f.type, this.exit(u), f.value = s;
    const c = (
      /** @type {HastElement} */
      f.data.hChildren[0]
    );
    c.type, c.tagName, c.children.push({ type: "text", value: s }), this.data.mathFlowInside = void 0;
  }
  function o(u) {
    this.enter(
      {
        type: "inlineMath",
        value: "",
        data: {
          hName: "code",
          hProperties: { className: ["language-math", "math-inline"] },
          hChildren: []
        }
      },
      u
    ), this.buffer();
  }
  function l(u) {
    const s = this.resume(), f = this.stack[this.stack.length - 1];
    f.type, this.exit(u), f.value = s, /** @type {Array<HastElementContent>} */
    // @ts-expect-error: we defined it in `enterMathFlow`.
    f.data.hChildren.push({ type: "text", value: s });
  }
  function a(u) {
    this.config.enter.data.call(this, u), this.config.exit.data.call(this, u);
  }
}
function Rc(e) {
  let t = (e || {}).singleDollarTextMath;
  return t == null && (t = !0), r.peek = i, {
    unsafe: [
      { character: "\r", inConstruct: "mathFlowMeta" },
      { character: `
`, inConstruct: "mathFlowMeta" },
      {
        character: "$",
        after: t ? void 0 : "\\$",
        inConstruct: "phrasing"
      },
      { character: "$", inConstruct: "mathFlowMeta" },
      { atBreak: !0, character: "$", after: "\\$" }
    ],
    handlers: { math: n, inlineMath: r }
  };
  function n(o, l, a, u) {
    const s = o.value || "", f = a.createTracker(u), c = "$".repeat(Math.max(Or(s, "$") + 1, 2)), p = a.enter("mathFlow");
    let h = f.move(c);
    if (o.meta) {
      const d = a.enter("mathFlowMeta");
      h += f.move(
        a.safe(o.meta, {
          after: `
`,
          before: h,
          encode: ["$"],
          ...f.current()
        })
      ), d();
    }
    return h += f.move(`
`), s && (h += f.move(s + `
`)), h += f.move(c), p(), h;
  }
  function r(o, l, a) {
    let u = o.value || "", s = 1;
    for (t || s++; new RegExp("(^|[^$])" + "\\$".repeat(s) + "([^$]|$)").test(u); )
      s++;
    const f = "$".repeat(s);
    // Contains non-space.
    /[^ \r\n]/.test(u) && // Starts with space and ends with space.
    (/^[ \r\n]/.test(u) && /[ \r\n]$/.test(u) || // Starts or ends with dollar.
    /^\$|\$$/.test(u)) && (u = " " + u + " ");
    let c = -1;
    for (; ++c < a.unsafe.length; ) {
      const p = a.unsafe[c];
      if (!p.atBreak) continue;
      const h = a.compilePattern(p);
      let d;
      for (; d = h.exec(u); ) {
        let x = d.index;
        u.codePointAt(x) === 10 && u.codePointAt(x - 1) === 13 && x--, u = u.slice(0, x) + " " + u.slice(d.index + 1);
      }
    }
    return f + u + f;
  }
  function i() {
    return "$";
  }
}
const _c = {
  tokenize: Nc,
  concrete: !0,
  name: "mathFlow"
}, Qt = {
  tokenize: Bc,
  partial: !0
};
function Nc(e, t, n) {
  const r = this, i = r.events[r.events.length - 1], o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0;
  let l = 0;
  return a;
  function a(y) {
    return e.enter("mathFlow"), e.enter("mathFlowFence"), e.enter("mathFlowFenceSequence"), u(y);
  }
  function u(y) {
    return y === 36 ? (e.consume(y), l++, u) : l < 2 ? n(y) : (e.exit("mathFlowFenceSequence"), B(e, s, "whitespace")(y));
  }
  function s(y) {
    return y === null || F(y) ? c(y) : (e.enter("mathFlowFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), f(y));
  }
  function f(y) {
    return y === null || F(y) ? (e.exit("chunkString"), e.exit("mathFlowFenceMeta"), c(y)) : y === 36 ? n(y) : (e.consume(y), f);
  }
  function c(y) {
    return e.exit("mathFlowFence"), r.interrupt ? t(y) : e.attempt(Qt, p, C)(y);
  }
  function p(y) {
    return e.attempt({
      tokenize: b,
      partial: !0
    }, C, h)(y);
  }
  function h(y) {
    return (o ? B(e, d, "linePrefix", o + 1) : d)(y);
  }
  function d(y) {
    return y === null ? C(y) : F(y) ? e.attempt(Qt, p, C)(y) : (e.enter("mathFlowValue"), x(y));
  }
  function x(y) {
    return y === null || F(y) ? (e.exit("mathFlowValue"), d(y)) : (e.consume(y), x);
  }
  function C(y) {
    return e.exit("mathFlow"), t(y);
  }
  function b(y, E, L) {
    let D = 0;
    return B(y, S, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
    function S(R) {
      return y.enter("mathFlowFence"), y.enter("mathFlowFenceSequence"), O(R);
    }
    function O(R) {
      return R === 36 ? (D++, y.consume(R), O) : D < l ? L(R) : (y.exit("mathFlowFenceSequence"), B(y, q, "whitespace")(R));
    }
    function q(R) {
      return R === null || F(R) ? (y.exit("mathFlowFence"), E(R)) : L(R);
    }
  }
}
function Bc(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return l === null ? t(l) : (e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), o);
  }
  function o(l) {
    return r.parser.lazy[r.now().line] ? n(l) : t(l);
  }
}
function jc(e) {
  let n = (e || {}).singleDollarTextMath;
  return n == null && (n = !0), {
    tokenize: r,
    resolve: $c,
    previous: qc,
    name: "mathText"
  };
  function r(i, o, l) {
    let a = 0, u, s;
    return f;
    function f(x) {
      return i.enter("mathText"), i.enter("mathTextSequence"), c(x);
    }
    function c(x) {
      return x === 36 ? (i.consume(x), a++, c) : a < 2 && !n ? l(x) : (i.exit("mathTextSequence"), p(x));
    }
    function p(x) {
      return x === null ? l(x) : x === 36 ? (s = i.enter("mathTextSequence"), u = 0, d(x)) : x === 32 ? (i.enter("space"), i.consume(x), i.exit("space"), p) : F(x) ? (i.enter("lineEnding"), i.consume(x), i.exit("lineEnding"), p) : (i.enter("mathTextData"), h(x));
    }
    function h(x) {
      return x === null || x === 32 || x === 36 || F(x) ? (i.exit("mathTextData"), p(x)) : (i.consume(x), h);
    }
    function d(x) {
      return x === 36 ? (i.consume(x), u++, d) : u === a ? (i.exit("mathTextSequence"), i.exit("mathText"), o(x)) : (s.type = "mathTextData", h(x));
    }
  }
}
function $c(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "mathTextData") {
        e[t][1].type = "mathTextPadding", e[n][1].type = "mathTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "mathTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function qc(e) {
  return e !== 36 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Hc(e) {
  return {
    flow: {
      36: _c
    },
    text: {
      36: jc(e)
    }
  };
}
const Uc = {};
function Vc(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || Uc, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), o = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), l = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(Hc(n)), o.push(Mc()), l.push(Rc(n));
}
const Wc = {
  components: {},
  linkOrdinanceClaused: !0
};
function Gc(e, t) {
  if (!e) return;
  const { components: n, linkOrdinanceClaused: r, ordinanceLink: i } = {
    ...Wc,
    ...t
  };
  if (r && i) {
    const o = /(\d{2}\.\d{2}(-s\d*)?(-\d+)?(-\d+\.\d+)*)/gi;
    e = e.replace(o, (l) => `[${l}](${i.replace("{{}}", l)})`);
  }
  return e = e.replaceAll(/```markdown/g, ""), e = e.replaceAll(/```$/g, ""), /* @__PURE__ */ J(
    Eu,
    {
      className: "prose dark:prose-invert prose-p:leading-relaxed prose-pre:p-0 break-words",
      remarkPlugins: [Oc, Vc],
      components: {
        p({ children: o }) {
          return /* @__PURE__ */ J("p", { className: "mb-2 text-base leading-5 whitespace-pre-wrap", children: o });
        },
        h1({ children: o }) {
          return /* @__PURE__ */ J("p", { children: /* @__PURE__ */ J("span", { className: "text-3xl font-bold", children: o }) });
        },
        h2({ children: o }) {
          return /* @__PURE__ */ J("h2", { className: "text-textPrimary mb-2 mt-4 text-2xl font-semibold leading-7", children: o });
        },
        h3({ children: o }) {
          return /* @__PURE__ */ J("p", { children: /* @__PURE__ */ J("span", { className: "text-xl font-bold", children: o }) });
        },
        h4({ children: o }) {
          return /* @__PURE__ */ J("p", { children: /* @__PURE__ */ J("span", { className: "text-lg font-bold", children: o }) });
        },
        ol({ children: o }) {
          return /* @__PURE__ */ J("ol", { className: "ml-6 mb-3 list-outside list-decimal text-base", children: o });
        },
        ul({ children: o }) {
          return /* @__PURE__ */ J("ul", { className: "ml-6 mb-3 list-outside list-disc text-base", children: o });
        },
        li({ children: o }) {
          return /* @__PURE__ */ J("li", { className: "mt-1", children: /* @__PURE__ */ J("span", { className: "relative text-base", children: o }) });
        },
        a({ node: o, ...l }) {
          var u;
          if (!o) return null;
          let a;
          try {
            a = new URL(((u = o.properties.href) == null ? void 0 : u.toString()) || "");
          } catch (s) {
            return console.error(s), null;
          }
          return /* @__PURE__ */ J(
            "a",
            {
              ...l,
              "aria-label": l.children ? void 0 : "Link to " + a.href,
              className: "text-textLink hover:text-textLinkHover text-base underline",
              href: a.href,
              rel: "noopener noreferrer",
              target: "_blank",
              tabIndex: 0
            }
          );
        },
        ...n
      },
      children: e
    }
  );
}
function Kc(e) {
  return fi(e);
}
export {
  Gc as c,
  Kc as f
};
//# sourceMappingURL=react-DikN064b.js.map
